<template>
	<div
		:style="`--theme-color: ${activeColor}; --theme-background-color: ${backgroundColor}`"
		v-if="(!isSyncingInProcess && (isMessengerVisible || isOpened))"
		class="rp-app"
		:class="{ 'rp-make-all-feilds-rtl': isRtl }"
		>
		<div id="preloader">
			<img 
				:key="image"
				v-for="image in preloadImages"
				:src="image"
				width="1"
				height="1"
			/>
			<!-- JUST TO LAOD THE ICONS PRIOR -->
			<i class="el-icon-arrow-right"></i>
		</div>
		<div
			class="rp-messenger-container"
			:class="{ 'opened': isOpened }"
			>
			<transition
				v-on:before-enter="beforeEnter"
				v-on:enter="enter"
				v-on:after-enter="afterEnter"
				v-on:enter-cancelled="enterCancelled"
				v-on:leave-cancelled="leaveCancelled"
				v-on:after-leave="afterLeave"
				name="fade">
				<div
					v-if="isOpened"
					:class="{ 'in-start': isInScreenStart, [screenType]: screenType, 'main-container-full-screen': isItFullScreen }"
					style="background:#fafafa;"
					v-bind:style="{ top: getMessengerTopSpace + 'px' }"
					class="rp-messenger"
					v-loading="showLoader"
					element-loading-background="rgba(0, 0, 0, 0)"
					>
					<!---Initial Screen with different types of cards
					Cards are conditional
						1. Order card - will be visible only when They have enabled order scenario
							and If the customer has atleast one order
						2. Help and support card - will be visible only when They have enable help and support scenarions
						3. StartContent(Start a new conversation) - This is a palceholder for help and support. We diplay this, only
							If Faq's scenarios are disabled
						4. Recent Conversations - Visible always
							
					-->
					<template
						v-if="screenType === screenTypes.SCREEN_TYPE_START"
						>	
						<div
							:style="{ backgroundColor: backgroundColor }"
							class="rp-messenger-header__start rp-messenger-header"
							
						/>
						<div  ref="RPMainScreen" class="rp-messenger-inner" :class="{ 'in-start': isInScreenStart, 'child-container-full-screen': isItFullScreen }" :style="{ overflow: 'auto' }">
							<StartHeader
								:opacity="startHeaderOpacity"
								:brandIcon="brandIcon"
								:greeting="greeting"
								:intro="intro"
								:websiteUrl="websiteUrl"
								:brandName="brandName"
								:changeAninamtion="changeAninamtion"
								:backgroundColor="backgroundColor"
								class="rp-messenger-header"
								id="startHeaderId"
								@setHeight="setMarginTopForListWidget"
								:animationDelay="animationDelay(4)"
								:showLoader="showLoader"
								:isItFullScreen="isItFullScreen"
								
							/>
							<div
								v-if="!showLoader"
								>
								<div
									v-for="(card,index) of startScreenCardsList"
									:key="'start-screen-card'+index"
									>
									<template
										v-if="card.id==='LAST_ORDER'"
									>
										<LastOrder
											:activeColor="activeColor"
											:class="[ changeAninamtion ? 'animated fast fadeInLeft' : 'animated fast justFadeInUp']"
											:orderDetails="allOrders"
											:style="{
												top: 0,
												animationDelay:	animationDelay(index+7)
											}"
											@onOrderClick="handleLastOrderViewClick"
											@onOrderHelpClick="handleOrderHelpClick"
											@openPreviousOrders="OpenAllPreviousOrders"
											@onOrderTrackUrlClick="fetchOrderShipmentDetails"
											class="rp-messenger-content-conversation-list-widget"
											style="padding:0;"
											v-if="isUserLoggedIn()"
											:header="'yourOrders'"
											:footerBtnLabel="'viewPreviousOrder'"
											:loading=" loadingOrders && orders.length === 0"
										/>
										<LoginFormVue
											v-else-if="!isUserLoggedIn()"
											@sendCode="codeSent"
											@loginSuccess="loginSuccess"
											:header="$t('orderList.loginToViewOrders')"
											:class="[ changeAninamtion ? 'animated fast fadeInLeft' : 'animated fast justFadeInUp']"
											:payload="{}"
											:style="{ 
												margin: '16px',
												top: 0,
												animationDelay:	animationDelay(index+7)
											}"
										/>
									</template>
									<StartContent
										v-if="['START_NEW_CONVERSATION', 'HELP_SUPPORT'].includes(card.id)"
										:class="[ changeAninamtion ? 'animated fast fadeInLeft' : 'animated fast justFadeInUp']"
										:style="{
											top: 0,
											animationDelay:	animationDelay(index+7)
										}"
										:replyTimeLabel="replyTimeLabel"
										:teamToRespond="teamToRespond"
										:nextAvailableBusinessHours="getNextAvailableBusinessHours"
										@onNewConversationButtonClick="handleNewConversationButtonClick"
										:helpAndSupportLabel="defaultHelpAndSupportLabel"
										:loading="scenariosDataLoading || systemPropsLoading || areConversationsLoading"
										:helpcenterStatus="helpcenterStatus"
										:conversations="startConversations"
										:conversationsLength="conversationsLength"
										@onViewAllButtonClick="screenType = screenTypes.SCREEN_TYPE_CONVERSATION_LIST"
										@onConversationClick="handleRecentConversationClick"
										:notificationCount="getNotificationCount"
									/>
									<LogoutVue
										:style="{
											top:0,
											animationDelay:	animationDelay(index+11)
										}"
										v-if="card.id === 'LOGOUT_CARD' && richPanelAuthData && !isUserLoggedIntoParent"
										:class="[ changeAninamtion ? 'animated fast fadeInLeft' : 'animated fast justFadeInUp']"
										@click="logoutFromMessenger"
									/>
								</div>
							</div>
							<FooterVue
								v-if="!showLoader && isItFullScreen" 
								:getPoweredByURL="getPoweredByURL"
								:helpcenterConfiguration="configuration"
								:brandName="brandName"
							/>
						</div>

						<div
							v-if="!showLoader && !isItFullScreen"
							:style="{
								animationDelay:	animationDelay(startScreenCardsList.length+13)
							}"
							class="rp-powered-by-richpanael animated fast fadeInUp"
							>
							<PoweredBy 
								:getPoweredByURL="getPoweredByURL"
							/>
						</div>
					</template>
					<template v-else>
						<div
							:style="{ backgroundColor: backgroundColor }"
							class="rp-messenger-header__start small-header rp-messenger-header"
							v-if="isItFullScreen" />
						<div class="rp-messenger-inner-screens" :class="{ 'child-container-full-screen-inner-screens': isItFullScreen }" :style="{ overflow: 'hidden' }">
							<!---One Conversation View -->
							<template
								v-if="screenType === screenTypes.SCREEN_TYPE_CONVERSATION || screenType === screenTypes.SCREEN_TYPE_INITIAL_FORM">
								<ConversationHeader
									class="rp-messenger-header"
									:activeColor="activeColor"
									@onBackButtonClick="goBackToPreviousPage"
									:replyTimeLabel="replyTimeLabelForConversationHeader"
									:intro="intro"
									:brandName="brandName"
									:messengerStyle="messengerStyle"
									:openHeader="isheaderOpen"
									:nextAvailableBusinessHours="getNextAvailableBusinessHours"
									:teamToRespond="teamToRespond"
									:notificationCount="getNotificationCount"
									:closingChat="closingChat"
									@closeChat="closeChat"
									:canDisplayCloseChat="canDisplayCloseChat"
								/>
								<template 
									v-if="screenType === screenTypes.SCREEN_TYPE_INITIAL_FORM">
									<InitialForm 
										@submit="handleInitFormSubmit"
										:formConfiguration="formConfiguration"
										:formHeaderLabel="preChatFormTitle"
										class="animated fast fadeInRight"
									/>
								</template>
								<ConversationContent
									v-if="screenType === screenTypes.SCREEN_TYPE_CONVERSATION"
									class="rp-messenger-content"
									:messages="currentMessages"
									:isUserTyping="isUserTyping"
									:isLoading="areMessagesLoading"
									:typingUserId="typingUserId"
									:backgroundColor="backgroundColor"
									:conversationStatus="selectedConversationStatus"
									@onScroll="handleOnConversationMessagesScroll"
									@onEnterNewMessage="handleOnEnterNewMessage"
									@onTyping="handleOnTyping"
									@submit="handleMessageSubmit"
									@pickOption="handleMessagePickOption"
									@changeStatusOfConversation="changeStatusOfConversation"
									:getPoweredByURL="getPoweredByURL"
								/>
							</template>
							<!---Conversation List View -->
							<template
								v-else-if="screenType === screenTypes.SCREEN_TYPE_CONVERSATION_LIST">
								<ConversationListHeader
									class="rp-messenger-header"
									@onBackButtonClick="onBackButtonClick"
									:messengerStyle="messengerStyle"
									:listHeader="'chatListScreen.header'"
								/>
								<ConversationListContent
									class="rp-messenger-content"
									:conversations="conversations"
									@onNewConversationButtonClick="handleNewConversationButtonClick"
									@onConversationClick="handleConversationClick"
									:getPoweredByURL="getPoweredByURL"
								/>
							</template>
							<!---Scenarios View -->
							<template
								v-else-if="screenType === screenTypes.SCREEN_HELP_AND_SUPPORT"
								>

									<ConversationHeader
										class="rp-messenger-header"
										:activeColor="activeColor"
										:brandName="brandName"
										:intro="intro"
										:messengerStyle="messengerStyle"
										:nextAvailableBusinessHours="getNextAvailableBusinessHours"
										:openHeader="isheaderOpen"
										:replyTimeLabel="replyTimeLabelForConversationHeader"
										:teamToRespond="teamToRespond"
										@onBackButtonClick="onHelpAndSupportBackClick"
										:headerForScenarios="true"
										:notificationCount="getNotificationCount"
										
									/>
									<div class="scroll-breadcrumb-and-content">
										<ScenarioBreadCrumb
											@breadCrumbClick="handleBreadCrumbClick"
											:breadCrumbHandler="breadCrumbHandler"
											:isItFullScreen="isItFullScreen"
										/>
										<!-- <div> -->
											
										<div 
											v-if="!showLoader" 
											class="rp-messenger-screen-help-and-support-list-content-scroller"
											:style="{ paddingBottom : isItFullScreen ? '0px' : '90px' }"
										>
											<PreviousOrders 
												v-if="currentScenario.scenarioId === 'YOUR_ORDERS'"
												@onOrderHelpClick="handleOrderHelpClick"
												@onOrderClick="onOrderClick"
												@onViewMoreOrders="onViewMoreOrders"
												class="animated fast fadeInLeft"
												:orderDetails="allOrders"
												:loadingOrders="loadingOrders"
												:activeColor="activeColor"
												:getAnimation="getAnimation"
												@onOrderTrackUrlClick="fetchOrderShipmentDetails"
											/>
											<template
												v-else-if="currentScenario.scenarioId.includes('VIEWING_ORDER')"
											>
												<DeliverySummary
													:scenarioAvailable="isOrderScenarioAvailable"
													:orderDetails="orderDetails"
													@onOrderHelpClick="handleOrderHelpClick"
													:getAnimation="getAnimation"
													:activeColor="activeColor"
													@onOrderTrackUrlClick="fetchOrderShipmentDetails"
												/>
											</template>
											<template 
												v-else-if="!isCurrentScenarioLeaf"
											>
												<LastOrder
													v-if="allOrders.length && breadCrumbHandler.length == 2"
													:activeColor="activeColor"
													:class="getAnimation"
													:orderDetails="allOrders"
													:style="{
														animationDelay:	'100ms'
													}"
													:actionsList="[]"
													@onOrderClick="handleLastOrderViewClick"
													@onOrderHelpClick="handleOrderHelpClick"
													@openPreviousOrders="OpenAllPreviousOrders"
													class="rp-messenger-content-conversation-list-widget"
													style="padding:0;"
													:header="'helpWithThisOrder'"
													:footerBtnLabel="'issueWithPreviousOrder'"
												/>
												<LoginFormVue
													v-else-if="!isUserLoggedIn() && breadCrumbHandler.length == 2"
													@sendCode="codeSent"
													@loginSuccess="loginSuccess"
													:header="$t('orderList.loginToViewOrders')"
													:class="getAnimation"
													:payload="{}"
													:style="{ 
														margin: '16px',
														top: 0,
														animationDelay:	2
													}"
												/>
												<!--- If scenario has child scenarios -->
												<HelpWithOtherIssues
													:activeColor="activeColor"
													:class="getAnimation"
													:style="{
														animationDelay:	'200ms'
													}"
													:headerText="currentScenarioName"
													:listOfIssues="currentScenario.children"
													@handleParentScenarioClick="onChildClick"
													@onOrderClick="handleLastOrderViewClick"
													@onOrderTrackUrlClick="fetchOrderShipmentDetails"
													:selectedOrderData="orderDetails"
													:breadCrumbHandler="breadCrumbHandler"
													:helpcenterHeader="configuration.faqLabel"
												/>
											</template>

											<template
												v-else-if="currentScenario.scenarioId.includes('TRACKING_ORDER')"
											>
												<OrderModelVue 
													:orderData="orderDetails"
													@onOrderClick="handleLastOrderViewClick"
													@onOrderHelpClick="handleOrderHelpClick"
												/>
												<ShipmentDetails
													:class="getAnimation"
													:style="{
														animationDelay:	'200ms'
													}"
													v-for="(shipment,index) in orderShipmentDetails"
													:key="index"
													:orderShipmentDetails="shipment"
													:order="orderDetails"
												> 
												</ShipmentDetails>
											</template>
											
											<!--- If scenario doesn't have children and type of order and can select items -->
											<OrderSummary
												v-else-if="currentScenario.showDetails || (currentScenario.canSelectItems && currentScenario.blockType === 'ORDER')"
												:activeColor="activeColor"
												:order="orderDetails"
												:class="getAnimation"
												:properties="properties"
												@orderConversation="handleOrderConversation"
												@scenarioEvent="scenarioEvent"
												@switchToHomeScreen="switchToHomeScreen"
												@moveToScenario="moveToScenario"
												:scenarioName="currentScenarioName"
												:customerProperties="customerProperties"
												:responseText="currentScenario.responseText"
												:ctaList="ctaList || []"
												@ctaButtonClick="ctaButtonClick"
												:isCollectUserInputEnabled="currentScenario ? currentScenario.isCollectUserInputEnabled : false"
												:chatUserInputs="currentScenario ? currentScenario.chatUserInputs : []"
												@handleScenarioPreChatFormSubmit="handleScenarioPreChatFormSubmit"
												:isExternalHelpdesk="isExternalHelpdesk"
												:submittingPrechatFormData="submittingPrechatFormData"
												:canSelectItems="currentScenario ? currentScenario.canSelectItems : false"
												:defaultActionType="currentScenario ? currentScenario.defaultActionType : 'CONTACT_SUPPORT'"
											/>
											<!--- If scenario is leaf -->
											<ScenarioContent
												v-else
												:activeColor="activeColor"
												:class='["animated","fast","fadeInRight"]'
												:ctaList="ctaList || []"
												:responseText=" currentScenario ? currentScenario.responseText : ''"
												:scenarioName="currentScenarioName"
												:customerProperties="customerProperties"
												:properties="properties"
												@handleChatClick="handleChatClick"
												@switchToHomeScreen="switchToHomeScreen"
												@moveToScenario="moveToScenario"
												@orderHelpClick="handleOrderHelpClick"
												@scenarioEvent="scenarioEvent"
												@ctaButtonClick="ctaButtonClick"
												@handleScenarioPreChatFormSubmit="handleScenarioPreChatFormSubmit"
												:isExternalHelpdesk="isExternalHelpdesk"
												:submittingPrechatFormData="submittingPrechatFormData"
												:selectedOrderData="orderDetails"
												:showStartChat="currentScenario ? currentScenario.showStartChat : true"
												:defaultActionType="currentScenario ? currentScenario.defaultActionType : 'CONTACT_SUPPORT'"
												:isCollectUserInputEnabled="currentScenario ? currentScenario.isCollectUserInputEnabled : false"
												:chatUserInputs="currentScenario ? currentScenario.chatUserInputs : []"
												:blockType="currentScenario ? currentScenario.blockType : ''"	
											/>
										</div>
											<FooterVue 
												v-if="!showLoader && isItFullScreen && !isCurrentScenarioLeaf" 
												:helpcenterConfiguration="configuration" 
												:getPssoweredByURL="getPoweredByURL"
												:brandName="brandName"
											/>
									</div>
									<!-- </div> -->
								<!-- </div> -->

									<div 
										v-if="!isItFullScreen"
										:style="{
											animationDelay:	animationDelay(startScreenCardsList.length+1)
										}"
										class="rp-powered-by-richpanael animated fast fadeInUp">
										<PoweredBy 
											:getPoweredByURL="getPoweredByURL" 
										/>
									</div>
							</template>
							<template
								v-else-if="screenType === screenTypes.LOGIN_SCREEN"
								>
								<LoginVue
									@onBackButtonClick="onBackButtonClick"
									@loginSuccess = "loginSuccess"
									:initialPayload="initialPayloadForLoginPage"
									:isItFullScreen="isItFullScreen"
								/>
							</template>
							<FooterVue 
								v-if="!areMessagesLoading && !showLoader && isItFullScreen"
								:helpcenterConfiguration="configuration"
								:getPoweredByURL="getPoweredByURL"
								:brandName="brandName"
							/>
						</div>
					</template>
				</div>
			</transition>
			<div
				v-if="!isOpened && (newInAppMessages.length || newConversationMessages.length)"
				:class="{ 'in-start': isInScreenStart }"
				v-bind:style="{ top: getMessengerTopSpace + 'px' }"
				class="rp-messenger-notification-container"
				>
				<div
					v-for="(inAppMessage, index) in newInAppMessages"
					:key="inAppMessage.id"
					>
					<NewInAppMessageNotification
						v-if = "inAppMessage.inAppMessageType!=='popup'"
						:inAppMessage = "inAppMessage"
						:brandName = "brandName"
						@handleClick = "handleInAppMessageNotificationClick"
						:notificationIndex = "index"
						class="animated fast justFadeInUp"
						:style="{
							animationDelay:	animationDelay(index+3)
						}"
					/>
				</div>
				<div
					v-for="(newMessage, index) in newConversationMessages"
					:key="newMessage.id"
					>
					<!--This is not in app message. Here the use case is to display the unread messages--->
					<NewInAppMessageNotification
						:inAppMessage = "newMessage"
						:brandName = "brandName"
						@handleClick = "handleNewMessageClick"
						:notificationIndex = "index"
						class="animated fast justFadeInUp"
						:style="{
							animationDelay:	animationDelay(index+3)
						}"
					/>
				</div>
			</div>
			<el-dialog
				:visible.sync="dialogVisible"
				:show-close="false"
				width="55%"
				class="popup-message-dialog"
				>
				<NewInAppMessageNotification
					v-if = "newInAppPopupTypeMessages && newInAppPopupTypeMessages.length>0"
					:inAppMessage="newInAppPopupTypeMessages[0]"
					:brandName = "brandName"
					@handleClick = "handleInAppMessageNotificationClick"
				/>
			</el-dialog>
			<el-dialog
				:visible.sync="isFullImageOpen"
				:show-close="false"
				width="fit-content"
				class="full-image-preview"
				@closed="closeImagePreview"
				>
				<img @click="closeImagePreview" :src="fullViewOfImage" />
			</el-dialog>
			<template v-if="!isItFullScreen">
				<transition 
					name="bounce"
					>
					<template v-if="!isOpened && (showGreetingAnimation || showGreetingAnimationEnd)">
						<div
							@click="toggleMessengerOpen"
							:class="{ 
								'opened': isOpened,
								'greeting-animation': !isOpened && showGreetingAnimation,
								'greeting-animation-end': !isOpened && showGreetingAnimationEnd
							}"
							class="rp-messenger-trigger flexFullCenter bounce-enter-active "
							:style="messengerIcon"
							>
							<el-badge 
								type="danger"
								:hidden="isOpened || getNotificationCount <= 0"
								:value="getNotificationCount" :max="9" class="count-on-trigger"
								:class="{
									'when-greeting-animation-active': !isOpened && (showGreetingAnimation || showGreetingAnimationEnd)
								}"
								>

								
								<div class="count-on-trigger__greeting-animation">
									<div class='greeting-message'>
										<AgentsInfo
											:replyTimeLabel="replyTimeLabel"
											:teamToRespond="teamToRespond"
											:nextAvailableBusinessHours="getNextAvailableBusinessHours"
											:maxUser="anyOneOnline ? 3 : 2"
											:avatarSize="40"
											:showAvailability="false"
											:avatarMarginY="0"
											class="agents-info-in-greeting"
											:class="{
												'fadeInOpacity-leave-active': !isOpened && showGreetingAnimationEnd
											}"
											:showOnlineStatus="false"
											:showOnlineStatusOnLastUser="anyOneOnline"
										/>
										<span class="greeting-text" v-if="showGreetingAnimationMessage"
											:class="{
												'fadeInOpacity-leave-active': !isOpened && showGreetingAnimationEnd
											}"
											>
											<h4 :title="greetingAnimationHeader">{{ greetingAnimationHeader }}</h4>
											<p>{{ greetingAnimationDesc }}</p>
										</span>
									</div>
									<div
										:class="{
											'count-on-trigger__greeting-animation____rp-logo--closed': !isOpened && showGreetingAnimationEnd,
											'count-on-trigger__greeting-animation____rp-logo--opened': showGreetingAnimationMessage,
										}"
										:style="messengerStyle"
										class="count-on-trigger__greeting-animation____rp-logo"
										>
										<div
											class="rp-logo-icon">
											<Icon />
										</div>
									</div>
								</div>
							</el-badge>
						</div>
					</template>
					<template
						v-else-if="isOpened || (!showGreetingAnimation && !showGreetingAnimationMessage && !showGreetingAnimationEnd)"
						>
						<div
							@click="()=>toggleMessengerOpen({ shrinkMessenger: false })"
							:class="{ 
								'opened': isOpened,
								'greeting-animation': !isOpened && showGreetingAnimation,
								'greeting-animation-end': !isOpened && showGreetingAnimationEnd
							}"
							class="rp-messenger-trigger flexFullCenter bounce-enter-active "
							:style="messengerIcon"
							>
							<el-badge 
								type="danger"
								:hidden="isOpened || getNotificationCount <= 0"
								:value="getNotificationCount" :max="9" class="count-on-trigger"
								:class="{
									'when-greeting-animation-active': !isOpened && (showGreetingAnimation || showGreetingAnimationEnd)
								}"
								>
								<div
									v-if="isOpened"
									class="rp-cross-icon">
									<Cross />
								</div>
								<div
									v-else
									class="rp-logo-icon">
									<Icon />
								</div>
							</el-badge>
						</div>
					</template>
				</transition>
				<div
					@click="toggleMessengerOpen"
					:class="{ 'opened': isOpened }"
					class="rp-messenger-mobile-close-trigger"
					>
					<div class="rp-cross-icon">
						<Cross />
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import MessengerEventBus from './MessengerEventBus'
import striptags from 'striptags';
import Vue from 'vue'
import io from 'socket.io-client';
import { mapActions, mapGetters } from 'vuex';
function uuid() {
	return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(c) {
			return	(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
		}
	)
}
import { createNamespacedHelpers } from 'vuex';
import { getCookieByName } from './utils';
import { initialize as InitializeAxios } from './models/Axios.js';

import Icon from './components/Icon';
import Cross from './components/Cross';
import StartHeader from './components/StartHeader';
import StartContent from './components/StartContent';
import ConversationHeader from './components/ConversationHeader';
import ConversationContent from './components/ConversationContent';
import ConversationListHeader from './components/ConversationListHeader';
import ConversationListContent from './components/ConversationListContent';
import LastOrder from './components/Widgets/Orders/LastOrder'
import HelpWithOtherIssues from './components/Widgets/HelpWithOtherIssues';
import ScenarioContent from "./components/Widgets/HelpAndSupport/ScenarioContent";
import PreviousOrders from "./components/Widgets/Orders/PreviousOrders";
import DeliverySummary from './components/Widgets/Orders/DeliverySummary'
import OrderSummary from './components/Widgets/Orders/OrderSummary';
import ScenarioBreadCrumb from './components/Widgets/ScenarioBreadCrumb';
import LoginVue from './components/Login';
import LoginFormVue from './components/Login/LoginForm.vue';
import LogoutVue from './components/Login/Logout'
import ShipmentDetails from './components/Widgets/HelpAndSupport/ShipmentDetails';
import OrderModelVue from './components/Widgets/HelpAndSupport/OrderModel';
import eventTypes from './eventTypes.json';
import Conversation from './models/Conversation';
import Person from './models/Person';
import Message from './models/Message';
import Tenant from './models/Tenant';
import Lead from './models/Lead';
import transitionMixin from './mixins/transitionMixin';
import eventTrackingMixin from './mixins/eventTrackingMixin';
import File from './models/File';
import OrderModel from './models/Order'
import { HELPDESK_SOCKET_URL, WEBSOCKET_ENDPOINT } from './config';
import {
	getNextAvailableTime
} from './helper/getNextAvailableTime';
import { DateTime } from "luxon";

//icons 
import NewInAppMessageNotification from './components/NewInAppMessageNotification';
import AgentsInfo from './components/AgentsInfo.vue'

//element io 
import Badge from 'element-ui/packages/badge'
import Dialog from 'element-ui/packages/dialog'
import InitialForm from './components/TextMessage/InitialForm';
import {
	CONTACT_DETAILS_FORM,
	CONVERSATION_MESSAGE_TYPE_TEXT,
	CONVERSATION_TYPE_MESSENGER,
	delay,
	EMAIL_REQUIREMENT_ALWAYS,
	EMAIL_REQUIREMENT_NEVER,
	EMAIL_REQUIREMENT_OUTSIDE,
	getKeyForSentece,
	MEDIA_TYPE_FILE,
	MEDIA_TYPE_FORM,
	MEDIA_TYPE_GIF,
	MEDIA_TYPE_ORDER,
	MEDIA_TYPE_RATING,
	MEDIA_TYPE_RATING_FORM,
	MEDIA_TYPE_STICKER,
	MEDIA_TYPE_TEXT,
	MEDIA_TYPE_JOURNEY,
	MESSAGE_FROM_CUSTOMER,
	MESSAGE_FROM_OPERATOR,
	parsePropertyTags,
	QUALIFY_LEADS_FORM,
	RPAudioManager,
	SCREEN_HELP_AND_SUPPORT,
	SCREEN_ORDER_ADDRESS,
	SCREEN_ORDER_HELP_WITH_ORDER,
	SCREEN_ORDER_SUMMARY,
	LOGIN_SCREEN,
	EXTERNAL_HELPDESK,
	SCREEN_ORDER_VIEW_PREVIOUS_ORDERS,
	SCREEN_TYPE_CONVERSATION,
	SCREEN_TYPE_CONVERSATION_LIST,
	SCREEN_TYPE_INITIAL_FORM,
	SCREEN_TYPE_ORDER,
	SCREEN_TYPE_START,
	TYPE_LEAD,
	TYPE_USER,
	truncate,
	CONTENT_WINDOW_MESSAGE_EVENTS,
	PARENT_WINDOW_MESSAGE_EVENTS
} from './constants.js';

import {canISeeMessenger} from './helper/canIseeMessenger'
Vue.component(Badge.name, Badge);
Vue.component(Dialog.name, Dialog);
const AUDIO_URL = 'https://s3-us-west-2.amazonaws.com/richpanel-assets/audio';
const messageSentAudio = new Audio(`${AUDIO_URL}/MessageSent.mp3`)
import RpRuleEngine from '@bit/richpanel.rp-rule-engine.rp-rule-engine';
import PoweredBy from './shared/PoweredBy'
import FooterVue from './shared/Footer'
import InternalLink from './components/InternalLink'

export default {
	
	mixins: [transitionMixin, eventTrackingMixin, InternalLink ],

	data() {
		return {
			isTabNotified: false,
			closingChat: false,
			loggedInWithOrder: '',
			submittingPrechatFormData: "Loading",
			socketStatus: '',
			openedMessenger: false,
			richPanelAuthData: "",
			initialPayloadForLoginPage: {},
			startHeaderOpacity: 1,
			navigatedFrom: '',
		    getAnimation: [],
			startScreenCards: [
				{
					order: 1,
					for: 'conversations',
					id: 'HELP_SUPPORT',
				},
				{
					order: 2,
					id: 'LAST_ORDER',
				},
				{
					order: 3,
					for: 'home',
					id: 'HELP_SUPPORT',
				},
				{
					order: 4,
					id: 'LOGOUT_CARD'
				}
			],
			showGreetingAnimation: false,
			getNextAvailableBusinessHours: '',
			showGreetingAnimationMessage: false,
			showGreetingAnimationEnd: false,
			screenTypes: {
				SCREEN_TYPE_START,
				SCREEN_TYPE_CONVERSATION,
				SCREEN_TYPE_CONVERSATION_LIST,
				SCREEN_TYPE_INITIAL_FORM,
				SCREEN_TYPE_ORDER,
				SCREEN_HELP_AND_SUPPORT,
				SCREEN_ORDER_VIEW_PREVIOUS_ORDERS,
				SCREEN_ORDER_HELP_WITH_ORDER,
				SCREEN_ORDER_ADDRESS,
				SCREEN_ORDER_SUMMARY,
				LOGIN_SCREEN,
			},
			changeAninamtion:false,
			typingUserId:'',
			headerScrolllHeight: null,
			isheaderOpen: false,
			screenType: SCREEN_TYPE_START,
			isOpened: false,
			conversationsDB: {},
			conversationIds: [],
			sourcePersonId: '',
			messagesDB: {},
			conversationMessagesMap: {},
			selectedConversationId: '',
			socket: '',
			cookieId: window.richpanelSettings.cookieId,
			dummyConversationCreatedAt: '',
			isUserTyping: false,
			userTypingTimeoutId: '',
			areConversationsLoading: false,
			areMessagesLoading: false,
			IFrame: null,
			isSyncingInProcess: true,
			isMessengerVisible: true,
			isConversationStillBeingCreated: false,
			messageQueue: [],
			topSpaceForWidget: '105px',
			sendNotifierTimeOut: '',
			fullViewOfImage: '',
			orderDetails:{},
			allOrders: [],
			scenarioLoading: false,
			scenariosDataLoading: false,
			systemPropsLoading: false,
			loadingOrders: false,
			loadingMessenger: false,
			breadCrumbHandler: [],
			afterLoginRedirectTo: null,
			actionsListForOrderInsideHelpAndSupport: [
				{
					buttonLabel: 'help',
					actionName: 'onOrderHelpClick',
				}
			]
		}
	},

	components: {
		AgentsInfo,
		Icon,
		Cross,
		StartHeader,
		StartContent,
		ConversationHeader,
		ConversationContent,
		ConversationListHeader,
		ConversationListContent,
		NewInAppMessageNotification,
		InitialForm,
		LastOrder,
		PreviousOrders,
		HelpWithOtherIssues,
		ScenarioContent,
		DeliverySummary,
		OrderSummary,
		ScenarioBreadCrumb,
		LoginVue,
		LoginFormVue,
		LogoutVue,
		ShipmentDetails,
		OrderModelVue,
		PoweredBy,
		FooterVue
	},

	computed: {
		isRtl() {
			if(this.brandData && this.brandData.language && this.brandData.language === 'ar') {
				return true
			} else {
				return false
			}
		},
		
		ctaList() {
			let ctaButtons = this.currentScenario ? this.currentScenario.ctaButtons : []
			let orderScenarioTree = {}
			let scenarioBreadCrumb = this.breadCrumbHandler.find(b => b.scenarioId === "HELP_AND_SUPPORT_ORDER" || b.scenarioId === "HELP_AND_SUPPORT") || {}
			orderScenarioTree = scenarioBreadCrumb.children || []

			let generalScenarioTree = scenarioBreadCrumb.generalScenarios || []
			let scenarios = [
				{ 	
					scenarioId: 'scenarios',
					children: [ ...orderScenarioTree, ...generalScenarioTree ] 
				}
			]
			let scenarioIdList = this.getAllScenariosId(scenarios)
			if(!ctaButtons) {
				return []
			}
			return ctaButtons.filter(c => c).filter(cta => {
				if(cta.actionType === "LOGIN") {
					if(this.isUserLoggedIn()) {
						cta.disabled = true
						cta.buttonText = "Already Logged In"
					}
				}
				if(cta.actionType === "HELPCENTER" && cta.scenarioId) {
					if(!scenarioIdList.includes(cta.scenarioId)) {
						return false
					}
				}
				return true
			})
		},
		canDisplayCloseChat() {
			if(!this.allowUsersToCloseChat) {
				return false;
			}
			if(this.selectedConversation && this.selectedConversation.status !== 'CLOSED'  && this.isAgentReplied){
				return true;
			}
			return false;
		},
		isAgentReplied() {
			if(this.currentMessages && this.currentMessages.length) {
				return this.currentMessages.some(msg=> msg.senderId !== 'operator' && msg.senderType === 'operator')
			}
			return false;
		},
		orderShipmentDetails() {
			return this.getOrderShipmentDetails
		},
		slideInAnimation() {
			if(this.configuration.style && Object.prototype.hasOwnProperty.call(this.configuration.style, 'slideInAnimation')) {
				return this.configuration.style.slideInAnimation
			}
			return true
		},
	isUserLoggedIntoParent() {
		return !!this.richpanelData['user_properties']
	},
	getPoweredByURL() {
		//quispify727
		return this.tenantId === 'quispify727' ? '#': `https://richpanel.com/get-richpanel/?partner=${this.tenantId}&utm_campaign=richpanel.com&utm_source=chat_window&utm_medium=referral`;
	},
	
	isExternalHelpdesk() {
		return this.$root.configuration.helpdeskConfig && this.$root.configuration.helpdeskConfig.type !== 'RICHPANEL'
	},

	allowUsersToCloseChat() {
		return typeof this.$root.configuration.allowUsersToCloseChat === 'boolean' ? this.$root.configuration.allowUsersToCloseChat : true;
	},

	helpcenterStatus() {
		return this.configuration.helpcenterStatus
	},

	isItFullScreen() {
		return this.configuration.helpcenterMode === 'fullscreen'
	},

	showOrderSummary() {
		return (this.currentScenario.showDetails || this.currentScenario.canSelectItems) && (this.orderDetails && this.orderDetails.products && this.orderDetails.products.length > 0)
	},
    isSupportScenarioAvailable() {
      return this.getScenarioAvailability('HELPANDSUPPORT');
    },
    isOrderScenarioAvailable() {
      return this.getScenarioAvailability('ORDER');
    },
		isFullImageOpen: {
			get() {
				return !!this.fullViewOfImage;
			},
			set() {
				this.fullViewOfImage = '';
			}
		},
		startScreenCardsList() {
			return this.startScreenCards.filter((card)=>{
				//conversations list
				if (card.id === 'HELP_SUPPORT' && card.for == "conversations" && this.areThereAnyRecentConversation) return true;
				//Order card
				if (card.id === 'LAST_ORDER' && this.helpcenterStatus) return true;
				//Order help and support
				if (card.id === 'HELP_SUPPORT' && card.for == "home" && !this.areThereAnyRecentConversation) return true;
				if(card.id === 'LOGOUT_CARD' && this.richPanelAuthData) return true;
				return false;
			})
		},
		areThereAnyRecentConversation() {
			return this.startConversations.length ? true : false;
		},
		preloadImages() {
			return [
				'https://messenger.richpanel.com/img/back.svg',
				'https://messenger.richpanel.com/img/shopping-bag.svg',
			].concat(Object.values(this.agentList).map(agent=> agent.imageURL))
		},
		getNotificationCount() {
			try {
				return this.newConversationMessages.length + this.newInAppMessages.length
			}
			catch(e) {
				return 0;
			}
			
		},
		isInitialFormSubmitted()  {
			return this.properties.isInitialFormSubmitted || false;
		},
		formConfiguration() {
			const conf = {
				formType: 'onlyEmail',
				fields: []
			}
			if(this.isEmailRequired) {
				conf.fields.push(
					{
						name: 'email',
						value: '',
						groupName: 'People Data'
					}
				)
			}
			if(this.isPreChatFormEnabled) {
				if(!this.preChatForm || !this.preChatForm.properties) return conf;
				const { properties } = this.preChatForm;
				properties.forEach(({ propertyName, groupName })=> {
					conf.fields.push({ name: propertyName, groupName: groupName || 'People Data', value: '' })
				})

			}
			return conf;
		},
		anyOneOnline() {
			return false;
			// return !!this.activeAgentList.length
		},
		greetingAnimationHeader() {
			return this.anyOneOnline ? this.$t('greetingAnimation.weAreOnline') : this.$t('homeScreen.newConversationButton')
		},
		greetingAnimationDesc() {
			return this.anyOneOnline ? this.$t('greetingAnimation.chatWithUs') : truncate(this.replyTimeLabelForConversationHeader, 32);
		},

		brandName() {
			return this.configuration.brand;
		},
		brandData() {
			return this.configuration.brandData;
		},
		brandLogo() {
			return this.brandData.brandLogo || 'NA';
		},
		brandIcon() {
			return this.brandData.brandIcon || 'NA';
		},
		websiteUrl() {
		
			if(!this.configuration.helpcenterStyles) {
				return '';
			}
			if(!this.configuration.helpcenterStyles.socialMediaLink) {
				return '';
			}
			if(!this.configuration.helpcenterStyles.socialMediaLink.website) {
				return '';
			}
			return this.configuration.helpcenterStyles.socialMediaLink.website
		},
		brandId() {
			return this.brandData.brandId
		},
		currency() {
			return this.configuration.currency || {  };
		},
		currencySymbol() {
			return this.currency.symbol || '$';
		},

		replyTime() {
			if(typeof this.configuration.replyTime === 'boolean'){
				return this.configuration.replyTime
			}
			return true;
		},

		routing() {
			return this.configuration.routing || {
				isActive: true,
				routingTo: 'unassigned',
				routingType: 'assignment'
  		};
		},

		contactDetails() {
			if(this.configuration.contactDetails){
				return this.configuration.contactDetails
			}
			return {
				isActive: true,
				askFor: 'email'
			};
		},

		qualification() {
			if(this.configuration.qualification)
				return this.configuration.qualification
			return {
				isActive: true,
				properties: [{
					propertyName:"firstName"
				}]
			};
		},

		emailRequirement() {
			try{
				return this.configuration.email.requirement || "never";
			}
			catch(e){
				return "never";
			}
		},

		isEmailRequired() {
			if(this.emailRequirement === EMAIL_REQUIREMENT_NEVER) return false;
			if(this.emailRequirement === EMAIL_REQUIREMENT_ALWAYS)
				return true;
			if(this.emailRequirement === EMAIL_REQUIREMENT_OUTSIDE) {
				let availability = getNextAvailableTime(DateTime, this.getAgentTimeZoneOffset, this.availability, this.$root.defaultLanguage)
				if(!availability.isItWorkingHour) return true;
			}
			return false;
		},

		preChatForm() {
			const preChatForm= {
				isEnabled: false,
				formTitle: 'Talk to us',
				properties: [{
					propertyName: "firstName"
				}]
			}
			try{
				return this.configuration.preChatForm || preChatForm
			}
			catch(e) {
				return preChatForm
			}
		},

		alsoAskForQualification() {
			try{
				return this.configuration.email.alsoAskForQualification || false;
			}
			catch(e) {
				return false
			}
		},

		isPreChatFormEnabled() {
			try {
				return this.preChatForm.isEnabled;
			} catch(e) {
				return false;
			}
		},

		preChatFormTitle() {
			try {
				return this.preChatForm.formTitle || 'Talk to us';
			} catch(e) {
				return 'Talk to us';
			}
		},

		preChatFormProperties() {
			return this.preChatForm.properties;
		},

		tenantId() {
			return this.properties.tenantId;
		},

		control() {
			if(this.configuration.control){
				return this.configuration.control
			}else{
				return {
					"messengerIconPosition": "right",
					"showMessengerToAllUsers": true,
					"sideSpacing": 20,
					"showMessengerToAllLeads": true,
					"bottomSpacing": 20,
					"canCreateNewConversations": true,
					advancedMessengerVisibility: false,
					visibilityCode: 'SHOW-CONTAINS',
					visibilityUrls: '',
					displayUserType: 'all-users',
					displayTimeType: 'all-time',
				};
			}
		
		},
		
		getMessengerTopSpace() {
			if(this.isItFullScreen) return 0;
			if(this.control.bottomSpacing <= 20) return 20;
			return this.control.bottomSpacing;
		},

		toPlaySound() {
			try{
				return this.configuration.style.toPlaySound;
			}
			catch(e){
				return true;
			}
		},

		messengerStyle() {
			return {
				backgroundColor: this.backgroundColor
			};
		},

		messengerIconPosition() {
			const position = this.control.messengerIconPosition;
			const bottomSpacing = 20;
			const sideSpacing = 20;

			if (position === 'left') {
				return {
					left: sideSpacing + 'px',
					bottom: bottomSpacing + 'px'
				}
			} else {
				return {
					right: sideSpacing + 'px',
					bottom: bottomSpacing + 'px'
				}
			}

		},

		replyTimeLabel() {
			try{
				//return this.configuration.availability.replyTime
				return this.$t(`sentences.${getKeyForSentece(this.configuration.availability.replyTime)}`);
			}catch(e){
				console.error(e)
				return this.$t(`sentences.${getKeyForSentece("The team typically replies in a few hours.")}`);
			}
		},
		replyTimeLabelForConversationHeader() {
			let label = this.replyTimeLabel.replace('The team typically ', '');
			label = label[0].toUpperCase() + label.slice(1, label.length)
			return label;
		},
		availability() {
			const defaultAvailability = {
				replyTime: "The team typically replies in a few hours.",
				startTime: "09:00",
				endTime: "17:00",
				selectedDay: "Weekdays"
			};
			try {
				return this.configuration.availability || defaultAvailability;
			} catch(e) {
				return defaultAvailability;
			}
		},
		activeColor() {
			try {
				return this.configuration.style.activeColor;
			}catch(e){
				return '#296df6';
			}
		},

		boxShow() {
			try {
				return this.configuration.style.boxShadow;
			}catch(e){
				return "0 4px 15px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5)"
			}
		},

		backgroundColor() {
			try{
				return this.configuration.style.backgroundColor;
			}catch(e){
				return '#286df6';
			}
		},
		teamToRespond() {
			try {
				return this.configuration.style.teamToRespond || 'all';
			}
			catch (e) {
				return 'all';
			}
		},

		intro() {
			try{
				return this.configuration.welcome.intro;
			}catch(e){
				return 'How can we help you?'
			}
		},

		greeting() {
			const properties = this.properties;
			let greetMessage = `Hi <no-data data-name="firstName" data-fallback="There"></no-data>,`;
			try{
				greetMessage = this.configuration.welcome.greeting;
			}
			catch(e){
				console.error(e,"Undefined Greeting message going by default")
			}
			const text = parsePropertyTags(greetMessage, (name, fallback) => {
				if (properties) {
					if (name in properties) {
						return properties[name];
					}
				}

				if (fallback === null || fallback === undefined) {
					return '';
				}

				return fallback;
			});
			return text;
		},

		messengerIcon(){
			const { messengerIconPosition, messengerStyle } = this
			if(this.isOpened) {
				return { 
					...messengerIconPosition
				}
			} 
			else {
				return { 
					...messengerStyle,
					...messengerIconPosition
				}
			}

		},

		conversationsLength() {
			return this.conversations.length;
		},

		isInScreenStart() {
			return this.screenType === SCREEN_TYPE_START;
		},

		isInScreenConversation() {
			return this.screenType === SCREEN_TYPE_CONVERSATION;
		},

		startConversations() {
			let timeBefore7days = Date.now() - (7*24*60*60*1000)
			if(!this.conversations) {
				return [];
			}
			let recentConversations = this.conversations.filter((conv)=> conv.lastMessageTime > timeBefore7days);
			if(!recentConversations) {
				return [];
			}

			return recentConversations.slice(0, 2);
		},

		conversations() {
			const a = this.conversationIds.map(id => this.conversationsDB[id]);
			return a.sort((a, b) => {
				return b.lastMessageTime - a.lastMessageTime
			})
		},
		newInAppMessages() {
			const conversations = this.conversationIds.map(id => this.conversationsDB[id]);
			const inAppMessages = conversations.filter((conversation) => {
				return conversation.inAppMessageStatus === 'sent' && conversation.inAppMessageType !== "popup"
			})
			return (inAppMessages.sort((a, b) => {
				return a.updatedAt - b.updatedAt
			})).slice(0,1)
		},
		newInAppPopupTypeMessages() {
			const conversations = this.conversationIds.map(id => this.conversationsDB[id]);
			const inAppMessages = conversations.filter((conversation) => {
				return conversation.inAppMessageStatus === 'sent' && conversation.inAppMessageType === 'popup'
			})
			return inAppMessages.sort((a, b) => {
				return b.updatedAt - a.updatedAt;
			})
		},
		newConversationMessages() {
			const conversations = this.conversationIds.map(id => this.conversationsDB[id]);
			const inAppMessages = conversations.filter((conversation) => {
				
				return conversation.inAppMessageStatus !== 'sent' && conversation.userUnReadMessagesCount > 0;
			})
			return (inAppMessages.sort((a, b) => {
				return a.updatedAt - b.updatedAt
			})).slice(0,1)
		},

		currentMessages() {
			const { selectedConversationId, conversationMessagesMap, messagesDB } = this;
			return ((conversationMessagesMap[selectedConversationId] || []).map(id => messagesDB[id]).filter(message =>  !message.hideInMessenger)).sort((a,b)=>{ return a.createdAt - b.createdAt })
		},

		selectedConversation() {
			return this.conversationsDB[this.selectedConversationId];
		},
		selectedConversationStatus() {
			try {
				return this.selectedConversation.status
			} catch(e){
				return 'OPEN';
			}
		},

		richpanelData() {
			return this.$root.richpanelSettings;
		},

		configuration() {
			if(this.$root.configuration && this.$root.configuration.brandData) {
				this.$root.configuration.brand = this.$root.configuration.brandData.brandName;
				this.$root.configuration.brandData = this.$root.configuration.brandData;
			}
			if(!this.$root.configuration.currency) {
				this.$root.configuration.currency = {
					code: 'USD',
					country: 'United States of America',
					name: 'United States Dollar',
					symbol: '$',
				};
			}
			if(this.$root.configuration.currency && this.$root.configuration.currency.code === 'INR') {
				this.$root.configuration.currency.symbol = '₹'
			}
			return this.$root.configuration;
		},
		getAgentTimeZoneOffset() {
			if(this.$root.localization.timezone) {
				return 'UTC'+this.$root.localization.timezone.split(' ').pop();
			}
			return 'UTC-04:00';
		},
		getTheCurrentTimeOfAgent() {
			return DateTime.local().setZone(this.getAgentTimeZoneOffset)
		},
		dialogVisible() {
			return this.newInAppPopupTypeMessages && this.newInAppPopupTypeMessages.length>0;			
		},

		...mapGetters({
			tenantConversationProperties: "conversationProperties",
			tenantPeopleProperties: "tenantProperties",
			personId: 'personId',
			scenarioList: 'scenarioList',
			properties: 'userProperties',
			teams: 'teams',
			teamsAndUsers: 'teamsAndUsers',
			usersByTeam: 'usersByTeam',
			allAssignee: 'allAssignee',
			agentList: 'agentList',
			activeAgentList: 'activeAgentList',
			selectedConversationDetails: 'selectedConversation',
			orders: 'orders',
			customerProperties: 'customerProperties',
			scenarioPeopleProperties: 'scenarioPeopleProperties',
			scenarioConversationProperties: 'scenarioConversationProperties',
			getOrderShipmentDetails: "getOrderShipmentDetails"
		}),

		currentScenario() {
			if(this.breadCrumbHandler.length) {
				let currentScene = this.breadCrumbHandler[this.breadCrumbHandler.length-1];
				return currentScene;
			}
			else 
				return {};
		},

		isCurrentScenarioLeaf() {
			if(this.currentScenario.children && this.currentScenario.children.length <= 0) return true;
			return false
		},
		currentScenarioName() {
			const {
				currentScenario
			} = this;

			if(!currentScenario) {
				return '';
			}

			if(currentScenario.scenarioId === 'HELP_AND_SUPPORT_ORDER') {
				return this.$t('orderList.helpWithThisOrder')
			}
			return currentScenario.scenarioName
		},

		showLoader() {
			if(this.loadingMessenger) return true;
			if(this.scenarioLoading) return true;
			// if(this.loadingOrders && this.orders.length<=0) return true;
			return false;
		},
		defaultHelpAndSupportLabel() {
			if(this.helpcenterStatus) {
				return this.$t('homeScreen.newConversationButton')
			}
			return this.$t('homeScreen.startConversation')
		},

		helpAndSupportLabel() {
			if(this.helpcenterStatus) {
				return this.configuration.faqLabel || this.$t('homeScreen.newConversationButton')
			}
			return this.$t('homeScreen.startConversation')
		}

	},

	watch: {
		isOpened(val) {
			//this.SET_SELECTED_CONVERSATION
		},
		headerScrolllHeight(val){
			//if(val <= ){
			//	this.isheaderOpen = true
			//}else {
				//this.isheaderOpen = false
			//}
		},
		"properties.email"(val) {
			let payload = {
				properties: {
					rpcuid: val
				},
				eventName: 'setrpcuid',
			}
			this.trackEvent({
				payload
			})
		}
	},

	async mounted() {
		window.addEventListener('focus', this.onWindowFocus);
		window.addEventListener('blur', this.onWindowBlur);
		console.time('Time took to display the messenger bubbel')
		this.richPanelAuthData = this.richPanelAuth();
		window.addEventListener("wheel", this.handleWheelEvent)
		window.addEventListener('message', this.receiveMessageFromParentWebsite, false)
		
		InitializeAxios(this.configuration.tenantId);
		await Promise.all([
			this.syncWithServer(),
			this.FETCH_ALL_AGENT(this.configuration.id),
			this.FETCH_TEAM_DETAILS(this.configuration.id)
		])

		console.timeEnd('Time took to display the messenger bubbel')
		

		this.loadSystemProps();
		this.checkForFullScreen()
		this.checkIfMessengerShouldBeActiveByUserType();
		RPAudioManager.initialize({ toPlaySound: this.toPlaySound, isMessengerVisible: this.isMessengerVisible });

		this.getNextAvailableBusinessHours = this.getNextAvailableBusinessHoursData()
		this.isSyncingInProcess = false;

		this.loadConversations();

		this.initSocket()

		//Test purpose
		//const response = await Lead.updateProperties(this.cookieId, { 'email' : '', 'phone': '', firstName: '', lastName: '', isInitialFormSubmitted: false, areYouAnExistingCustomer:'' }, { appClientId: this.configuration.id });
		// // console.log(response)
		let animationStatus = sessionStorage ? sessionStorage.getItem('greetingAnimation') : false;
		if(this.slideInAnimation && !this.isOpened && !animationStatus) {
			setTimeout(() => {
				if(!this.isOpened && !this.areThereAnyNewMessageNotifications()) {
					this.showGreetingAnimation = true;
					if(sessionStorage) {
						sessionStorage.setItem('greetingAnimation', true)
					}
					this.sendMessageToParentWindow({})
					setTimeout(()=> {
						this.showGreetingAnimationMessage = true;
					}, 700)
					
					this.animateTrigger()
				}
			}, 2000)
		}
		// this.loadingMessenger = false;
		MessengerEventBus.$on('SHOW_FULL_IMAGE', this.showFullImage)
		MessengerEventBus.$on("SCENARIO_BACK_BUTTON_CLICK", this.onHelpAndSupportBackClick)
		//Test for receive mesage from website
		// setTimeout(()=>{
		// 	this.receiveMessageFromParentWebsite(
		// 		{
		// 			data: JSON.stringify({
		// 				actionName: 'CREATE_NEW_CONVERSATION',
		// 				payload: {
		// 					initalMessage: "I'm not able to place an order"
		// 				}
		// 			})
		// 		}
		// 	)
		// }, 10000)
		document.documentElement.style.setProperty('--theme-color', this.activeColor);
		document.documentElement.style.setProperty('--theme-background-color', this.backgroundColor);
		document.documentElement.style.setProperty('--theme-bottom-position', this.control.bottomSpacing+'px');
		this.loginIfCredsProvidedInURL()

		parent.postMessage(PARENT_WINDOW_MESSAGE_EVENTS.MESSENGER_LOADED, '*');
	},
	beforeDestory() {
		// window.removeEventListener('focus', this.onWindowFocus);
		// window.removeEventListener('blur', this.onWindowBlur);
		MessengerEventBus.$off('SHOW_FULL_IMAGE', this.showFullImage)
		MessengerEventBus.$off("SCENARIO_BACK_BUTTON_CLICK", this.onHelpAndSupportBackClick)
		window.removeEventListener('scroll', this.handleWheelEvent);
		window.removeEventListener('message', this.receiveMessageFromParentWebsite, false)
	},

	methods: {
		getAgentName(senderId) {
			const { agentList } = this
			let agentData = agentList[senderId]
			if(agentData) {
				return agentData.firstName || 'operator';
			}
			return 'operator';
		},
		ctaButtonClick(ctaButton) {
			this.redirectTo(ctaButton)
		},
		onWindowFocus() {
			// this.sendMessageToParentWindowAboutNotifications(dataForEvent)
			if(this.isTabNotified && window.parent.pageTitleNotification) {
				window.parent.pageTitleNotification.off();
				this.isTabNotified = false;
			}
		},
		removeAllSocketListeners() {
			if(this.socket){
				this.socket.close();
				let eventNames = [
					'connect',
					'connect_error',
					'reconnecting',
					'disconnect',
					eventTypes.CONVERSATION_ASSIGNEE_UPDATED,
					eventTypes.NEW_CONVERSATION_STARTED,
					eventTypes.CONVERSATION_MESSAGES_LOADED,
					eventTypes.OPERATOR_TYPING,
					eventTypes.AGENT_STATUS_CHANGED,
					eventTypes.CONVERSATION_STATUS_UPDATED,
					eventTypes.AGENT_PROPERTIES_UPDATED,
					eventTypes.CONVERSATIONS_MERGED,
					eventTypes.NEW_IN_APP_MESSAGE_CREATED,
					eventTypes.USER_UNREAD_MESSAGES_COUNT_CONVERSATION,
					eventTypes.CHANGE_CONVERSATIONS_CREATOR_BY_COOKIEID
				]
				for(let eve of eventNames){
					this.socket.removeAllListeners(eve)
				}
			}
		},

		initSocket() {
			this.removeAllSocketListeners()
			this.socket = io(HELPDESK_SOCKET_URL, {
				path: WEBSOCKET_ENDPOINT,
				query: {
					cookieId: this.cookieId,
					tenantId: this.tenantId
				},
				transports: ['websocket'],
				// forceNew : true
			});

			this.socket.on('connect', e => {
				if(this.socketStatus === 'Reconnecting...' ) {
					if(this.selectedConversationId){
						setTimeout(()=>{
							this.loadMessagesOfConversation({
								id: this.selectedConversationId
							});
							this.loadConversations()
						}, 1000)
					}
				}
				this.socketStatus = 'Connected';
			});

			this.socket.on('connect_error', e => {
				this.socketStatus = 'Connection Error...';
			});

			this.socket.on('reconnecting', e => {
				this.socketStatus = 'Reconnecting...';
			});

			this.socket.on('disconnect', e => {
				this.socketStatus = 'Disconnected!';
			});


			this.socket.on(eventTypes.CONVERSATION_ASSIGNEE_UPDATED, data => {
				this.handleConversationAssigneeUpdate({ eventData: data })
			});

			this.socket.on(eventTypes.NEW_CONVERSATION_STARTED, conversation => {
				conversation.message.isDirty = false;
				this.handleNewConversationAdded(conversation);
			});

			this.socket.on(eventTypes.CONVERSATION_NEW_MESSAGE_ADDED, message => {
				if(message.hideInMessenger) {
					//Don't display message when agent chooses reply only via email
					return;
				}

				if (!(message.id in this.messagesDB)) {
					RPAudioManager.play(RPAudioManager.CONTEXT_NEW_MESSAGE);
					if(window.parent.pageTitleNotification) {
						let countOfUnreadMessages = this.newConversationMessages ? this.newConversationMessages.length : 1;
						if(!countOfUnreadMessages) {
							countOfUnreadMessages = 1;
						}
						window.parent.pageTitleNotification.on(`(${countOfUnreadMessages}) new messages`, 1e3);
						this.isTabNotified = true;
					}
				}

				const { conversationId } = message;
				if (conversationId in this.conversationsDB) {
					this.handleNewMessageAdded({ conversationId, message });
					// this.sendMessageToParentWindowAboutNotifications()
				}
			});

			this.socket.on(eventTypes.CONVERSATION_MESSAGES_LOADED, data => {
				const { id, messages } = data
				this.handleAfterMessagesLoaded({ id, messages })
			});

			this.socket.on(eventTypes.OPERATOR_TYPING, data => {
				this.typingUserId = data.operatorId
				this.handleAgentTyping(data['conversationId']);
			});

			//on agent online /offline socket status updated
			this.socket.on(eventTypes.AGENT_STATUS_CHANGED, data => {
				this.handleAgentStatusUpdated(data)
			})
			this.socket.on(eventTypes.CONVERSATION_STATUS_UPDATED, data => {
				Vue.set(this.conversationsDB[data.id], 'status', data.status)
			})

			this.socket.on(eventTypes.AGENT_PROPERTIES_UPDATED, this.handleAgentPropertiesUpdated)
			this.socket.on(eventTypes.CONVERSATIONS_MERGED, this.conversationsMerged)

			//new in app message created
			this.socket.on(eventTypes.NEW_IN_APP_MESSAGE_CREATED, inAppMessage => {
				RPAudioManager.play(RPAudioManager.CONTEXT_NEW_MESSAGE);
				this.handleNewConversationAdded(inAppMessage)
			})
			this.socket.on(eventTypes.USER_UNREAD_MESSAGES_COUNT_CONVERSATION, this.USER_UNREAD_MESSAGES_COUNT_CONVERSATION)
			this.socket.on(eventTypes.CHANGE_CONVERSATIONS_CREATOR_BY_COOKIEID, () => {
				this.resyncUserData({ richpanelSettings: this.$root.richpanelSettings.user_properties || null })
			})
		},
		async loginIfCredsProvidedInURL(){
			if(!this.isUserLoggedIn() && this.configuration.orderId && this.configuration.pincode){
				const { 
					status,
					message,
					encryptedData,
					userProperties,
				} = await this.TRY_ORDER_LOGIN({
					orderNumber: this.configuration.orderId,
					zipcode: this.configuration.pincode,
					appClientId: this.$root.configuration.id,
					authType: this.$root.configuration.authType || 'OTP',
					});

				if(status){
					this.loginSuccess({ encryptedData, userProperties, orderNumber: this.configuration.orderId })
					return;
				}
			}
			
		},
		async conversationsMerged(data) {
			const {
				masterConversationId,
				mergeableConversationIds
			} = data;
			if(this.selectedConversationId === masterConversationId){
				this.loadMessages(this.selectedConversationId)
			}
			for(let mergeableConversationId of mergeableConversationIds){
				let conversationIdIndex = this.conversationIds.indexOf(mergeableConversationId)
				if(conversationIdIndex>-1){
					this.conversationIds.splice(conversationIdIndex, 1);
					if(this.selectedConversationId === mergeableConversationId){
						this.selectedConversationId = this.conversationIds[conversationIdIndex] || this.conversationIds[conversationIdIndex-1] || this.conversationIds[0]
						this.loadMessages(this.selectedConversationId);
					}
				}
			}
		},
		trackInitialEvent() {
			let payload = {
				properties: {},
				eventName: this.isItFullScreen ? 'visited_customer_portal' : 'opened_messenger',
			}
			setTimeout(()=>{
				this.trackEvent({ payload })
			}, 1000)
		},
		scenarioEvent({ status, scenarioId = '', scenarioName = '' }) {
			if(!scenarioId) scenarioId = this.currentScenario.scenarioId;
			if(!scenarioName) scenarioName = this.currentScenario.scenarioName;
			let payload = {
				properties: {
					scenarioStatus: status,
					scenarioId,
					scenarioName,
				},
				eventId: this.richpanelData.sid+"_"+scenarioId,
				eventName: 'scenario_viewed'
			}
			this.trackEvent({ payload })
		},
		async loadSystemProps() {
			this.systemPropsLoading = true
			try {
				await this.GET_PROPERTIES_DATA()
				this.systemPropsLoading = false
			} catch(e){
				console.log(e);
				this.systemPropsLoading = false
			}
		},
		async fetchDataForAllCards({ rerouteAfterLoading }) {
			let promiseArray = [];
			if(this.helpcenterStatus) {
				promiseArray = [this.loadScenarios(), this.fetchPersonId()]
			}
			if(this.personId || this.sourcePersonId) {
				promiseArray.push(this.fetchCustomerProperties(this.personId || this.sourcePersonId))
			}
			await Promise.all(promiseArray)
			if(rerouteAfterLoading === 'helpcenter') {
				await this.onHelpAndSupportClick({ blockType: 'HELP_AND_SUPPORT'})
			}
			else if(rerouteAfterLoading === 'new-conversation') {
				//
			}
			if(this.loggedInWithOrder){
				// let order = this.orders.find((order)=>order.id === this.loggedInWithOrder); 
				// if(!order) {
				// 	order = await this.getOneOrder(this.loggedInWithOrder)
				// }
				// if(order){
				// 	this.handleLastOrderViewClick(order);
				// }
			}
		},
		handleAssignmentAfterCreatingConversation(assigneeData) {
			if(assigneeData && assigneeData.assignee && assigneeData.assignee != "unassigned") {
				let eventData = {
					id: assigneeData.id,
					assignee: assigneeData.assignee
				}
				this.handleConversationAssigneeUpdate({ eventData })
			} else if(assigneeData.id && (!this.helpcenterStatus || !this.isSupportScenarioAvailable)) {
				try {
					Conversation.runAutomationRule({ 
						conversationId: assigneeData.id,
						canExecuteForScenarios: false,
						canDoAgentAssignment: true,
						canSendAutoRespondMessages: false,
					})
				} catch(e) {
					console.log(e)
				}
			}
		},
		handleConversationAssigneeUpdate({ eventData }) {
			let conversation = this.conversationsDB[eventData.id]
			conversation.assignee = eventData.assignee
			Vue.set(this.conversationsDB, eventData.id, conversation)
			this.SET_SELECTED_CONVERSATION({})
			this.SET_SELECTED_CONVERSATION(conversation)
		},
		async fetchOrderShipmentDetails(order,blockType) {
			this.screenType = this.screenTypes.SCREEN_HELP_AND_SUPPORT
			await this.fetchFullfillmentDetails(order);
			this.orderDetails = order
			this.getAnimation = ["animated","fast","fadeInRight"]
			let orderLabel = this.$t('orderList.orderLabel') ;
			if (blockType = "ORDER") {
				await this.onOrderClick(order)
			}
			let scenario = {
				scenarioName: this.$t('orderList.trackingOrderLabel').toLowerCase(),
				scenarioId: `TRACKING_ORDER`,
				children: [],
			}
			this.breadCrumbHandler.push(scenario)
			this.scenarioEvent({
				status: 2,
				...scenario,
			})
		},
		async fetchFullfillmentDetails(order) {
			const { appClientId, orderId, tenantId } = order || this.orderDetails;
			this.loadingMessenger = true;
			try {
				await this.GET_ORDER_SHIPPING_DETAILS({ orderId, appClientId, tenantId  })
			} catch(e) {
				this.loadingMessenger = false
				console.log(e)
			}
			this.loadingMessenger = false
		},
		richPanelAuth() {
			return localStorage.getItem('rpMessengerAuth')
		},
		//this status will be displayed only when agents socket status is offline
		getNextAvailableBusinessHoursData() {
			let availability = getNextAvailableTime(DateTime, this.getAgentTimeZoneOffset, this.availability, this.$root.defaultLanguage)
			if(!availability.success) {
				//this should never occur. Incase if occurs fallback case display away
				console.error("Failed to calculate the next avaialble time.")
				return 'Away';
			}
			if(availability.isItWorkingHour){
				//it is working hour but agent is not available display away
				return 'Away';
			}
			//Not working hour so display the calculated time
			const hours = parseFloat((availability.agentWillBeBackIn.hours).toFixed(2));
			//If it is less than an hour show the granualirity in minutes
			if(hours < 1) return `${this.$t('sentences.BACK_IN')} ${ parseFloat((hours*60).toFixed(0))} ${this.$t('sentences.MINUTES')}`
			//To local timestamp
			let availableOn = availability.agentWillBeBackAt.toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit'});
			return hours<=12 ? `${this.$t('sentences.BACK_IN')} ${hours.toFixed(0)} ${this.$t('sentences.HOURS')}` : `${this.$t('sentences.BACK_ON')} ${availableOn} ${this.whatIsMyLocalTimeZone(availability.agentWillBeBackAt)}`;
		},
		logoutFromMessenger() {
			this.loadingMessenger = true;
			localStorage.removeItem('rpMessengerAuth')
			// this.socket.disconnect();
			// this.socket.connect();
			this.loggedInWithOrder = '';
			this.richPanelAuthData = "";
			this.allOrders = [];
			// this.reSyncUserData({})
			const payload= {
				eventName: 'logout',
				properties: {}
			}
			this.trackEvent({ payload })
			setTimeout(()=>{
				this.loadingMessenger = false;
			}, 500)
		},

		codeSent({ ...payload }) {
			this.screenType = this.screenTypes.LOGIN_SCREEN;
			this.initialPayloadForLoginPage = payload;
		},

		isUserLoggedIn() {
			if(this.richpanelData['user_properties'] || this.richPanelAuthData) {
				return true;
			}
			return false;
		},

		async reSyncUserData({ richpanelSettings: user_properties }) {
			// this.loadingMessenger = true;
			this.conversationsDB = {}
			this.conversationIds = [];
			this.areConversationsLoading = true;
			this.loadingOrders = true;
			await this.syncWithServer({ ...this.richpanelData, user_properties });
			this.initSocket();
			this.loadConversations();
			try {
				this.RESET_ORDERS_DATA()
			} catch(e) {
				console.error('RESET_ORDERS_DATA', e)
			}
			this.fetchDataForAllCards({ rerouteAfterLoading: 'home' });
			// this.loadingMessenger = false;
		},

		async loginSuccess({ encryptedData, userProperties, orderNumber = '' }) {
			
			localStorage.setItem('rpMessengerAuth', encryptedData)
			this.richPanelAuthData = encryptedData;
			const payload= {
					eventName: 'identify',
					properties: {
						source: 'messenger',
						authType: this.$root.configuration.authType || "OTP"
					}
			}
			if(userProperties) {
				if(userProperties.id) {
					delete userProperties.id;
				}
				payload.userProperties = JSON.stringify(userProperties)
			}
			if(orderNumber) {
				this.loggedInWithOrder = orderNumber
			}
			this.trackEvent({ payload })
			this.onBackButtonClick()
			if(this.afterLoginRedirectTo) {
				this.redirectTo(this.afterLoginRedirectTo)
				this.afterLoginRedirectTo = null
			}
		},

		areThereAnyNewMessageNotifications() {
			const {
				newInAppMessages = [],
				newConversationMessages = [],
			} = this;
			return !!(newInAppMessages.length || newConversationMessages.length)
		},

		receiveMessageFromParentWebsite(event) {
			//TODO: Check for security 
			let message = event.data;
			try {
				message = JSON.parse(message);
			} catch(e) {
				return;
			}
			const {
				actionName,
				payload
			} = message;
			switch(actionName) {
				case 'RESYNC_USER_DATA':
					const {
						richpanelSettings,
						cookieId,
					} = payload;
					if(cookieId) {
						this.cookieId = cookieId;
						window.richpanelSettings.cookieId = cookieId;
						this.$root.richpanelSettings.cookieId = cookieId;
					}
					if(payload.eventSource && payload.eventSource == 'website') {
						window.richpanelSettings.user_properties = richpanelSettings;
						this.$root.richpanelSettings.user_properties = richpanelSettings;
						if(richpanelSettings){
							localStorage.removeItem('rpMessengerAuth')
							// this.socket.disconnect();
							this.richPanelAuthData = "";
						}
					}
					this.reSyncUserData({ richpanelSettings })
					break;
				case 'LAUNCH_MESSENGER':
					this.expandIFrame()
					if(!this.isOpened) this.toggleMessengerOpen({ newStateOfMessenger: true })
					break;
				case 'LAUNCH_PRECHAT_SURVEY':
					this.expandIFrame()
					if(!this.isOpened) this.toggleMessengerOpen({ newStateOfMessenger: true })
					this.handleNewConversationButtonClickFromRecent()
					break;
				case 'CREATE_NEW_CONVERSATION':
					this.expandIFrame()
					if(!this.isOpened) this.toggleMessengerOpen({ newStateOfMessenger: true })
					this.handleNewConversationButtonClickFromRecent(false)
					const {
						initalMessage
					} = payload;
					this.handleOnEnterNewMessage({ type: MEDIA_TYPE_TEXT, value: initalMessage })
					break;
				case 'LAUNCH_HELP_CENTER':
					this.expandIFrame()
					if(!this.isOpened) this.toggleMessengerOpen({ newStateOfMessenger: true, rerouteAfterLoading:'helpcenter' })
					else this.onHelpAndSupportClick({})
					break;
				case CONTENT_WINDOW_MESSAGE_EVENTS.SHOW_MESSENGER:
					this.toggleMessengerOpen({});
					break;
				case CONTENT_WINDOW_MESSAGE_EVENTS.HIDE_MESSENGER:
					this.toggleMessengerOpen({});
					break;
				default:
					console.log("UNKNOWN ACTION", message); 
			}

		},
		checkForFullScreen() {
			if(this.isItFullScreen) {
				this.toggleMessengerOpen({})
			} else if(this.isMessengerAlreadyOpenedInThisTab()){
				this.toggleMessengerOpen({})
			}
		},
		isMessengerAlreadyOpenedInThisTab() {
			if(!sessionStorage) return false;
			if(!sessionStorage.getItem('messengerViewStatus')) return false;
			return true;
		},
		async getTheMessengerConf(subdomain) {
			return 
		},
		handleWheelEvent(e) {
			this.setTheOpacity(e);
		},

		setTheOpacity(e) {
			let el = this.$refs['RPMainScreen'];
		},

		showFullImage({ imageUrl }) {
			try {
				this.fullViewOfImage = imageUrl;
				this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: true })
			} catch(e) {
				console.log(e);
			}

		},
		closeImagePreview() {
			try {
				this.fullViewOfImage = '';
				this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false });
			} catch(e) {
				console.log(e)
			}
		},
		changeStatusOfConversation({ status }) {
			if(this.selectedConversationId && this.conversationsDB[this.selectedConversationId]){
				Vue.set(this.conversationsDB[this.selectedConversationId], 'status', status)
			}
		},
		whatIsMyLocalTimeZone(dataTimeObj) {
			try {
				let offsetValue = dataTimeObj.setLocale('en').offsetNameLong.split(' ').map(word => word[0]).join('');
				dataTimeObj.setLocale(this.$root.defaultLanguage)
				return offsetValue;
			} catch(e) {
				return '';
			}
		},
		// hasBackToMainPage(page) {
		// 	 if(page == this.screenTypes.SCREEN_TYPE_START) {
		// 		 console.log("hasBackToMainPAge",page == this.screenTypes.SCREEN_TYPE_START);
		// 		 this.indication = true;
		// 	 }else {
		// 		 this.indication = false;
		// 	 }
        // },
		animationDelay(index){
			if(this.changeAninamtion) {
				index -=4
			}
			return (index * 100) + "ms";
		},
		setMarginTopForListWidget( { height }) {
			if(height) {
				// let defaultTop = 50;
				this.topSpaceForWidget = (250 - height) + 'px'
			}
		},
		//socket handler usage and being used at operator messags also

		async USER_UNREAD_MESSAGES_COUNT_CONVERSATION(data) {
			//id is conversation id
			const { id, userUnReadMessagesCount } = data;
			if(this.isOpened && this.screenType === this.screenTypes.SCREEN_TYPE_CONVERSATION && id === this.selectedConversationId) {
				if(userUnReadMessagesCount <= 0) {
					let conversation = this.conversationsDB[id];
					Vue.set(conversation, 'userUnReadMessagesCount', 0)
					return; //must other wise it will be in loop
				}else {
					await this.clearUnReadMessages(id)
				}
			}
			else {
				let conversation = this.conversationsDB[id];
				Vue.set(conversation, 'userUnReadMessagesCount', userUnReadMessagesCount)
			}
			this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false })
		},

		handleAgentPropertiesUpdated(data) {
			this.UPDATE_AGENT_PROPERTIES(data)
		},

		async clearUnReadMessages(id) {
			let conversation = this.conversationsDB[id];
			const updatedData = {
				id,
				userUnReadMessagesCount: 0,
				tenantId: this.tenantId,
				cookieId: this.cookieId
			}
			Vue.set(conversation, 'userUnReadMessagesCount', 0);
			await Conversation.updateUserUnReadMessagesCountForConversation({ id })
			this.socket.emit(eventTypes.USER_UNREAD_MESSAGES_COUNT_CONVERSATION, updatedData)
		},
		goBackToPreviousPage() {
			if( this.conversations.length == 0 || this.screenType === this.screenTypes.SCREEN_TYPE_INITIAL_FORM){
				this.onBackButtonClick(this.screenTypes.SCREEN_TYPE_START)
			}
			else {
				if(this.navigatedFrom === 'HOME') {
					this.onBackButtonClick(this.screenTypes.SCREEN_TYPE_START)
					return;
				}
				this.onBackButtonClick(this.screenTypes.SCREEN_TYPE_CONVERSATION_LIST)
			}
		},
		emptyAllInAppMessages() {
			if(this.newInAppPopupTypeMessages && this.newInAppPopupTypeMessages.length>0)
				this.conversations.forEach((conversation) => {
					if(conversation.inAppMessageType === 'popup') 
						conversation.inAppMessageType = 'chat'
			})
		},
		handleAgentStatusUpdated({ type, members}) {
			if(type === 'all'){
				this.SET_ACTIVE_AGENTS(members);
				return;
			}
			//check for null values
			if(!members || !members[0]) return;
			//when single agent came online or went offline
			const { activeAgentList } =  this;
			// if(typeof(members[0].isChatAccess) === 'boolean')
			// 	this.UPDATE_AGENT_PROPERTIES({ agentId: members[0].operatorId, isChatAccess: members[0].isChatAccess})
			//online case
			if(members[0].status){
				const newList = [...activeAgentList, members[0]]
				this.SET_ACTIVE_AGENTS(newList);
				return;
			}
			//offline case
			//remove the agent from array
			const agentIndex = activeAgentList.findIndex((agent) => agent.operatorId === members[0].operatorId) 
			if(agentIndex>=0) {
				activeAgentList.splice(agentIndex, 1);
			}
			//update the active agent list in store
			this.SET_ACTIVE_AGENTS(activeAgentList);
			
		},
		clickOnNewConversationButtonClick(){
			this.SET_SELECTED_CONVERSATION(null);
		},
		toggleMessengerOpen({ newStateOfMessenger = 'toggle', rerouteAfterLoading = 'home', shrinkMessenger = true }) {
			/**
			 * Accepted values for newStateOfMessenger
			 * 'toggle'
			 * true
			 * false
			 */
			this.changeAninamtion = false;
			this.isOpened = newStateOfMessenger == 'toggle' ?  !this.isOpened : newStateOfMessenger;
			this.abortnGreetingAnimation()
			setTimeout(()=>{
				this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false, shrinkMessenger });
			}, 1000)
			if(!this.openedMessenger) {
				this.fetchDataForAllCards({ rerouteAfterLoading })
			}
			this.getNextAvailableBusinessHours = this.getNextAvailableBusinessHoursData()
			this.openedMessenger = true;
			if(this.isMessengerAlreadyOpenedInThisTab() && !this.isOpened && sessionStorage){
				sessionStorage.removeItem('messengerViewStatus')
			} else if(this.isOpened) {
				if(!this.isMessengerAlreadyOpenedInThisTab()){
					this.trackInitialEvent()
				}
				// if(sessionStorage){
				// 	sessionStorage.setItem('messengerViewStatus', true)
				// }
			}
			this.checkIfMessengerIsNotVisible()
		},
		checkIfMessengerIsNotVisible() {
			if(!this.isOpened && !this.isMessengerVisible) {
				let postMessage = { hasNotifications : false, hasPopupNotifications : false, heightOfNotifications : 0, richpanel_messenger_value: this.isOpened, isMessengerVisible: this.isMessengerVisible }
				parent.postMessage(postMessage, '*')
			}
		},
		abortnGreetingAnimation() {
			this.showGreetingAnimation = false;
			this.sendMessageToParentWindow({ shrinkMessenger: false })
			this.showGreetingAnimationMessage = false;
			this.showGreetingAnimationEnd = false;
		},
		checkIsInitialFormRequired() {
			if(this.properties.type === TYPE_USER)
				return false;
			if(this.isEmailRequired || this.isPreChatFormEnabled) {
				if(!this.isInitialFormSubmitted)
					return true;
			}

			return false;
		},
		async handleInitFormSubmit(event) {
			//saving in cookie
			const { formData } = await this.submitPrechatForm(event)
			const data = event.data;
			//Prepare conversation and message
			const { conversation, message } = await this.sendFormSubmissionMessage(formData, data);
			//Create Conversation and message
			const { isArchived = false } = await this.createConversationAfterSubmitForm({
				conversation,
				message
			});
			await this.handleConversationClick(conversation);
			await this.savePrechatQualificationProps({ triggeredFrom: 'REGULAR_PRECHAT' });
			if(!isArchived) {
				// Sending a confirmation message
				// After user submitted the form successfully
				// await this.sendFlowEndMessages({ conversationId: conversation.id });
				
				this.beginOperatorWhenConversationStarts(conversation.id)
			}
		},
		async handleScenarioPreChatFormSubmit(event) {
			//saving in cookie
			try {
				this.submittingPrechatFormData = "Loading";
				const { formData, fileList } = await this.submitPrechatForm(event)


				//Prepare conversation and message
				const data = event.data;
				let toCreateFormMessage = false;
				if(Object.keys(formData).length > 1) {
					toCreateFormMessage = true;
				}

				if(this.isExternalHelpdesk){
					toCreateFormMessage = false;
				}

				if(toCreateFormMessage) {
					const { id } = this.selectedConversation;
					const { message } = await this.createFormSubmissionMessage(formData, id, data)
					await this.handleOnEnterNewMessage({ type: 'form', value: `Chat on ${this.brandName}`}, message)
				}

				await this.savePrechatQualificationProps({ triggeredFrom: 'SCENARIO_PRECHAT' });
				if(this.isExternalHelpdesk) {
					await this.forwardToExternalHelpdesk({ formData, data, order: event.order || null })
				}
				this.submittingPrechatFormData = false;
				this.submittingPrechatFormData = "Success";
			} catch(e){
				console.error(e)
				this.submittingPrechatFormData = "Error";
			}
			
		},

		async forwardToExternalHelpdesk({ formData, data, order = null }) {

			const conversationPropertiesObj = {};
			const tenantPeoplePropertiesObj = {}
			this.tenantConversationProperties.forEach(prop => conversationPropertiesObj[prop.propertyName] = prop);
			this.tenantPeopleProperties.forEach(prop => tenantPeoplePropertiesObj[prop.propertyName] = prop);
			const properties = [];
			for(let propertyName in formData) {
				const property  = data.fields[propertyName];
				if (!property || ['id', 'customerMessageForExternalHelpdesk', 'isInitialFormSubmitted'].includes(propertyName)) {
					continue;
				}
				const { type, groupName } = property;
				let displayName  = propertyName
				if(groupName === 'Conversation Data'){
					const property = conversationPropertiesObj[propertyName]
					if(property){
						displayName = property.displayName;
					}
				}
				else if(groupName === 'People Data'){
					const property = tenantPeoplePropertiesObj[propertyName]
					if(property){
						displayName = property.displayName;
					}
				}

				properties.push({
					value: formData[propertyName],
					type,
					groupName,
					displayName,
					propertyName
				})

			}

			let conversation = {
				properties,
				mediaValue: formData.customerMessageForExternalHelpdesk || 'No message',
				scenarioName: this.currentScenarioName,
				order
			}

			let creator = this.properties;			
			if(this.customerProperties){
				creator = { ...creator, ...this.customerProperties }
			}

			const payload = {
				appClientId: this.configuration.id,
				brandId: this.brandId,
				tenantId: this.tenantId,
				conversation,
				creator,
			}
			return await this.CREATE_CONV_EXTERNAL_HELPDESK(payload)
		},

		
		//will return reply time lsbel if it is working hour other wise
		//returns the caluted reply time
		async getSuccessMessage() {
			let successMessage = this.replyTimeLabel
			let availability = getNextAvailableTime(
													DateTime,
													this.getAgentTimeZoneOffset,
													this.availability,
													this.$root.defaultLanguage
												);
			if(availability.success && !availability.isItWorkingHour) {
				const hours = Math.round(availability.agentWillBeBackIn.hours)
				let availableAt = availability.agentWillBeBackAt;
				availableAt = availableAt.toLocaleString({ weekday: 'long', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit' });
				let message = hours <= 6 ? `in ${hours} hours` : `on ${availableAt}`;
				if(hours < 1){
					return successMessage.trim();
				}
				if(hours <=6 )
					successMessage =  this.$t('botMessages.TEAM_WILL_BE_BACK_IN', { hours });
				else 
					successMessage = this.$t('botMessages.TEAM_WILL_BE_BACK_ON', { availableAt }) + ' '+ this.whatIsMyLocalTimeZone(availability.agentWillBeBackAt);
			}
			return successMessage.trim();
		},
		async youWillBeNotfiedMessage() {
			const { email } = this.properties; 
			if(email)
				return this.$t('botMessages.YOU_WILL_BE_NOTIFIED_EMAIL', { email });
			else 
				return this.$t('botMessages.YOU_WILL_BE_NOTIFIED_NO_EMAIL');
		},
		async sendOperatorMessageInterface({ conversationId, mediaValue }) {
			await delay(1000);
			await this.sendMessage({
				message: {
					id: uuid(),
					createdAt: Date.now(),
					cookieId: this.cookieId,
					tenantId: this.tenantId,
					conversationId,
					senderId: 'operator',
					type: CONVERSATION_MESSAGE_TYPE_TEXT,
					senderType: MESSAGE_FROM_OPERATOR,
					mediaType: MEDIA_TYPE_TEXT,
					mediaValue: mediaValue,
				},
				conversationId,
			})
			//check for new messages
			//if same conversation reset unread count, otherwise just increase the count
			let conversation = this.conversationsDB[conversationId];
			const latestCount = conversation.userUnReadMessagesCount ?  parseInt(conversation.userUnReadMessagesCount) + 1 : 1;
			if(conversation) {
				const updatedData = {
					id: conversationId,
					userUnReadMessagesCount: latestCount,
					tenantId: this.tenantId,
					cookieId: this.cookieId
				}
				this.socket.emit(eventTypes.USER_UNREAD_MESSAGES_COUNT_CONVERSATION, updatedData)
			}
		},
		async sendFlowEndMessages({ conversationId }) {
			//reply time bot is off no need send the following messages
			if(!this.replyTime)  {
				setTimeout(async () => {
					await Conversation.runAutomationRule({ conversationId, canDoAgentAssignment: false, });
				}, 3000)
				return;
			}
			//const successMessage = await this.getSuccessMessage();
			//await this.sendOperatorMessageInterface({ conversationId, mediaValue: successMessage});
			
			await this.sendReplyTimeMessageIfNeeded(conversationId)
			const notifyMessage  = await this.youWillBeNotfiedMessage();
			await this.sendOperatorMessageInterface({ conversationId, mediaValue: notifyMessage});
			let conversationData = this.conversationsDB[conversationId]
			if(this.helpcenterStatus || this.isEmailRequired || this.isPreChatFormEnabled) {
				const leaveYourMessage = this.$t('botMessages.LEAVE_YOUR_MESSAGE')
				await this.sendOperatorMessageInterface({ conversationId, mediaValue: leaveYourMessage});
			}
			setTimeout(async () => {
				await Conversation.runAutomationRule({ conversationId, canDoAgentAssignment: false });
			}, 3000)
		},

		async setConversationAssignee(conversation, newAssignee, operatorId) {
			// We have to remove this condition asap
			// routing type data is getting corrupted somwhere

			if(newAssignee === 'noting') {
				console.error("Incorrect assignee!!")
				return;
			}
			const { tenantId, cookieId, currencySymbol } = this;
			const { id, assignee, status } = conversation;
			if(id) {
				await Conversation.updateConversationAssignee({ id, operatorId, assignee: newAssignee, currencySymbol });
				this.socket.emit(
					eventTypes.CONVERSATION_ASSIGNEE_UPDATED,
					{
						id,
						cookieId,
						operatorId,
						tenantId,
						assignee: newAssignee,
						previousAssignee: assignee,
						status 
					}
				);
			}
		},

		async setConversationTags(conversation, tags) {
			const {tenantId, cookieId} = this;
			const {id, status} = conversation;
			await Conversation.updateConversationTags(id, tags);


			this.socket.emit(
					eventTypes.CONVERSATION_TAGS_UPDATED,
					{
						id,
						cookieId,
						tenantId,
						tags: tags,
						status
					}
			);
		},

		async setConversationStatus(conversation, newStatus, operatorId, askForRating) {
			const { tenantId, cookieId } = this;
			const { id, status, assignee } = conversation;
			
			await Conversation.updateConversationStatus({ id, operatorId, status: newStatus, askForRating });

			this.socket.emit(
				eventTypes.CONVERSATION_STATUS_UPDATED,
				{ 
					id, 
					cookieId,
					operatorId,
					tenantId,
					status: newStatus,
					previousStatus: status,
					assignee
				}
			)
		},

		async handleMessagePickOption({ message, option }) {
			const updatedMessage = {
				...message,
				optionValue: option,
				updatedAt: Date.now(),
				createdAt: message.createdAt || Date.now(),
				operationType: 'UPDATED',
			};
			this.$set(message, 'optionValue', option);
			await this.sendMessage({
				conversationId: this.selectedConversationId,
				message: updatedMessage
			}, false);
			const response = await Lead.updateProperties(this.cookieId, { areYouAnExistingCustomer: option }, { appClientId: this.configuration.id });
			this.SET_USER_PROPERTIES({ properties: response.data })
			this.$emit('messageOptionSelected', { message, option });
		},
		handleNewConversationButtonClickFromRecent(preChatSurveyCheck = true) {
			this.navigatedFrom = 'HOME'
			this.handleNewConversationButtonClick(preChatSurveyCheck)
		},
		handleNewConversationButtonClick(preChatSurveyCheck = true) {
			this.scrollToTopOfTheScreensOnNavigation()
			this.getNextAvailableBusinessHours = this.getNextAvailableBusinessHoursData()
			if(preChatSurveyCheck && this.helpcenterStatus && this.isSupportScenarioAvailable){
				this.onHelpAndSupportClick({ blockType: 'HELP_AND_SUPPORT'})
				return;
			}
			this.SET_SELECTED_CONVERSATION({})
			//Don't allow the Visitor
			//if he doesn't fill the initial form when required
			if(preChatSurveyCheck && this.isOpened && this.checkIsInitialFormRequired() && this.formConfiguration && this.formConfiguration.fields.length){
				this.screenType = SCREEN_TYPE_INITIAL_FORM
				return;
			}
			this.screenType = this.screenTypes.SCREEN_TYPE_CONVERSATION;
		},

		async OpenAllPreviousOrders() {
			await this.onHelpAndSupportClick({ blockType: 'ORDER' })
		},
		scrollToTopOfTheScreensOnNavigation() {
			const container = this.$refs.RPMainScreen;
			if(container){
				container.scrollTop = 0;
			}
		},
		async filterScenariosByRules({ scenariosData, orderProperties = {} }) {
			let scenarios = [];
			if(!scenariosData || !Array.isArray(scenariosData) || scenariosData.length<1){
				return scenarios;
			}
			let scenariosDataClone = JSON.parse(JSON.stringify(scenariosData))
			for(let scen of scenariosDataClone){				
				if(scen.children && scen.children.length){
					scen.children = await this.filterScenariosByRules({ scenariosData: scen.children, orderProperties })
				}
				if(scen.advancedVisibilitySettings && scen.advancedVisibilitySettings.matchPredicate && scen.advancedVisibilitySettings.predicates && scen.advancedVisibilitySettings.predicates.length){

					let isValid = await RpRuleEngine.getValidScenarios({ rules: [
						{ ...scen.advancedVisibilitySettings }
					], properties: { userProperties: { ...this.properties, ...this.customerProperties }, orderProperties } })

					if(isValid){
						scenarios.push(scen)
					}
				} else {
					scenarios.push(scen)
				}
			}
			return scenarios
		},

		async onHelpAndSupportClick({ blockType = 'HELP_AND_SUPPORT'}) {
			/**
			1. Check the scenario block type to get the exact scenarios
			2. Initalize the breadcrumb
			3. Set the screen to help and support
			4. Animate from right to left
			*/
			this.scrollToTopOfTheScreensOnNavigation()
			let scenarios = await this.filterScenariosByRules({ scenariosData: this.scenarioList.HELPANDSUPPORT });
			let superParentName = this.helpAndSupportLabel || "Start a conversation";
			let superParentId = 'HELP_AND_SUPPORT';
			//1
			if(blockType === 'ORDER') {
				let orderLabel = this.$t('orderList.yourOrders') ;
				superParentName = `${orderLabel}`;
				superParentId = `YOUR_ORDERS`;
				scenarios = [];
			}
			//2
			this.breadCrumbHandler = [
				{
					scenarioName: 'Home',
					scenarioId: 'HOME',
					children: []
				},
				{
					scenarioName: superParentName,
					scenarioId: superParentId,
					children: scenarios,
				}
			]
			//3
            this.screenType = this.screenTypes.SCREEN_HELP_AND_SUPPORT;
			//4 
			this.getAnimation = ["animated","fast","fadeInRight"]
			this.addALoaderForScenarios();
			if(this.isItFullScreen) {
				// this.trackEvent({ payload: {
				// 	properties: {},
				// 	eventName: 'visited_helpcenter'
				// }})
			}
		},

		handleLastOrderViewClick(order) {
			this.navigatedFrom = 'HOME';
			this.onOrderClick(order)
		},
		async handleOrderHelpClick(order) {
			this.breadCrumbHandler = [];
			// if(this.breadCrumbHandler.length<=2) {
			// }
			this.scenarioLoading = true;
			let orderPropertiesData = await OrderModel.getOrderObjectData({ id: order.id, tenantId: this.tenantId, appClientId: this.configuration.id })
			let orderProperties = JSON.parse(JSON.stringify(order));
			if(orderPropertiesData.status && orderPropertiesData.data){
				orderProperties = orderPropertiesData.data;
				const remainingData = orderProperties.remainingData;
				orderProperties = {
					...order,
					...orderProperties,
				}
				delete orderProperties.remainingData;
			}
			await this.onOrderClick(orderProperties)
			let scenarios = await this.filterScenariosByRules({ scenariosData: this.scenarioList.ORDER, orderProperties })
			let generalScenarios = await this.filterScenariosByRules({ scenariosData: this.scenarioList.HELPANDSUPPORT });
			this.breadCrumbHandler.push(
				{
					scenarioName: this.$t('orderList.help').toLowerCase(),
					scenarioId: `HELP_AND_SUPPORT_ORDER`,
					children: scenarios,
					generalScenarios: generalScenarios
				}
			)
			this.scenarioLoading = false;
		},

		async searchOrders(orderId, matchType="startswith") {
			if(!orderId) return;
			let orderData = await OrderModel.getOrderByOrderId({ personId: this.sourcePersonId, orderId: orderId, tenantId: this.tenantId, appClientId: this.configuration.id, matchType })
			if(orderData && orderData.data && orderData.data[0] && Object.keys(orderData.data[0])) {
				return orderData.data;
			}
			return null;
		},
		async getOneOrder(orderId) {
			let orders = await this.searchOrders(orderId, 'fullmatch');
			if(orders) {
				return orders[0]
			}
			return  null;
		},

		onHelpAndSupportBackClick() {
			let parentScenario = this.breadCrumbHandler[this.breadCrumbHandler.length-2];
			if(this.breadCrumbHandler.length === 2 || !parentScenario) {
				this.breadCrumbHandler = [];
				this.onBackButtonClick()
				return;
			}
			if(this.currentScenario.scenarioId.includes('VIEWING_ORDER') && this.navigatedFrom === 'HOME') {
				this.breadCrumbHandler = [];
				this.onBackButtonClick()
				return;
			}
			this.handleBreadCrumbClick(parentScenario)
		},

		async onOrderClick(order) {
			this.orderDetails = order;
			let orderLabel = this.$t('orderList.orderLabel') ;
			// if(this.breadCrumbHandler.length<2) {
				await this.OpenAllPreviousOrders()
			// }
			if(this.breadCrumbHandler.length === 2) {
				this.breadCrumbHandler.push(
					{
						scenarioName: `${orderLabel} ${order.orderName || "#" + order.orderNumber}`,
						scenarioId: `VIEWING_ORDER_${order.orderNumber}`,
						children: []
					}
				)
			}
			
			//this.screenType = this.screenTypes.SCREEN_ORDER_ADDRESS;
		},

		async handleMessageSubmit({ type, message, data }) {
			switch(type) {
				case MEDIA_TYPE_FORM:
					const { property } = data;
					if (property) {
						const { value, name, groupName = 'People Data' } = property;
						let vModelValue = property.vModelValue.trim();
						
						if (vModelValue) {
							const newMediaFormValue = message.mediaFormValue.map(prop => {
								if (prop.name === name) {
									return {
										name,
										value: vModelValue
									}
								} else return prop;
							})

							const updatedMessage = {
								...message,
								mediaFormValue: newMediaFormValue,
								updatedAt: Date.now(),
								createdAt: message.createdAt || Date.now(),
								operationType: 'UPDATED',
							};
							await this.sendMessage({ conversationId: this.selectedConversationId, message: updatedMessage }, false);
							if(groupName === 'Conversation Data') {
								try {
									await Conversation.updateConversationProperties({
										id: this.selectedConversation.id,
										properties: [{ name: name, value: vModelValue }],
									});
								} catch(e) {
									console.log('Error uploading the converastion props')
								}
							}
							else if(groupName === 'People Data') {
								const response = await Lead.updateProperties(this.cookieId, { [name]: vModelValue }, { appClientId: this.configuration.id });
								this.SET_USER_PROPERTIES({ properties: response.data })
							}

							
							const areAllFieldsFilled = updatedMessage.mediaFormValue.every(({ value }) => !!value);
							if (areAllFieldsFilled) {
								if(message.mediaValue === CONTACT_DETAILS_FORM) {
									this.$emit('messageEmailSubmitted', message);
								}
								else {
									this.$emit(QUALIFY_LEADS_FORM, message)
								}
									
							}
						}
					}
					return;
				case MEDIA_TYPE_RATING:
					this.updateRating({ message, data })
					return;
				case MEDIA_TYPE_RATING_FORM: 
					this.updateRatingForm({ message, data })
					return;
			}
		},
		async updateRating({ message, data }) {
			const { cookieId, tenantId } = this;
			const { conversationId }  = message;
			const updatedMessage = {
				...message,
				mediaValue: data.rating+'',
				updatedAt: Date.now(),
				createdAt: message.createdAt || Date.now(),
				operationType: 'UPDATED',
			};
			if(updatedMessage.mediaFormValue) {
				delete updatedMessage.mediaFormValue;
			}
			message.mediaValue = data.rating+'';
			// Call API to  update rating
			MessengerEventBus.$emit("SCROLL_TO_BOTTOM", {})
		 	const response = await Conversation.updateConversationRating({ id: conversationId, rating: data.rating });
			await this.sendMessage({ conversationId, message: updatedMessage }, false);

		},
		async updateRatingForm({ message, data }) {
			const { cookieId, tenantId } = this;
			const { conversationId }  = message;
			const updatedMessage = {
				...message,
				mediaFormValue: [{
					name: 'feedback',
					value: data.property.vModelValue
				}],
				updatedAt: Date.now(),
				createdAt: message.createdAt || Date.now(),
				operationType: 'UPDATED',
			};
			// Call Api to  update feedback
		  	const response = await Conversation.updateConversationFeedback({ id: conversationId, feedback: data.property.vModelValue });
			await this.sendMessage({ conversationId, message: updatedMessage }, false);
		},
		async submitInitForm({ data }) {
			let formData = {};
			for(let propertyName in data.fields) {
				const property  = data.fields[propertyName];
				if (property) {
					const { name } = property;
					let vModelValue = property.vModelValue.trim();
					formData[name] = vModelValue;
				}
			}
			//add submitted status
			formData['isInitialFormSubmitted'] = true;
			const response =  await Lead.updateProperties(this.cookieId, formData, { appClientId: this.configuration.id });
			this.SET_USER_PROPERTIES({ properties: response.data })
			return formData;
		},
		async submitPrechatForm({ data }) {
			let formData = {};
			let fileList = [];
			let categorizedData = {
				'People Data': [],
				'Conversation Data': []
			};

			for(let propertyName in data.fields) {
				const property  = data.fields[propertyName];
				if (property && propertyName !== 'id') {
					const { name, type, groupName } = property;
					let vModelValue = property.vModelValue
					switch(type){
						case "text":
						case "dropdownSelect":
						case "multiline":
						case "radioSelect":
							if(vModelValue.trim()) {
								formData[name] = vModelValue;
								categorizedData[groupName].push({
									name,
									value: vModelValue,
									type
								})
							}
							break;
						case "number":
							if(vModelValue) {
								formData[name] = vModelValue;
								categorizedData[groupName].push({
									name,
									value: vModelValue,
									type
								})
							}
							break;
						case "list":
							if(Array.isArray(vModelValue)) {
								formData[name] = vModelValue.join(', ');
								categorizedData[groupName].push({
									name,
									value: vModelValue,
									type
								})
								if(groupName === 'People Data'){
									categorizedData[groupName].push({
										name,
										value: JSON.stringify(vModelValue),
										type
									})
								}
							
							} else {
								if(vModelValue && vModelValue.trim()){
									try {
										formData[name] = JSON.parse(vModelValue).join(', ');
										categorizedData[groupName].push({
											name,
											value: vModelValue,
											type
										})
									} catch (error) {
										formData[name] = vModelValue;
										categorizedData[groupName].push({
											name,
											value: JSON.stringify([vModelValue]),
											type
										})
									}
								}
							}
							break;
						case "multiSelect":
							if(vModelValue.length > 0) {
								let joinedValues = ""
								vModelValue.forEach((val, index) => {
									if(index !== 0){
										joinedValues += `, ${val}`
									} else {
										joinedValues += val
									}
								})
								formData[name] = joinedValues;
								categorizedData[groupName].push({
									name,
									value: vModelValue,
									type
								})
							}
							break;
						case "yesOrNo":
						case "boolean":
							if(!vModelValue){
								break;
							} else if(vModelValue == "true"){
								formData[name] = 'Yes';
								categorizedData[groupName].push({
									name,
									value: 'Yes',
									type
								});
							} else if(vModelValue == "false") {
								formData[name] = 'No';
								categorizedData[groupName].push({
									name,
									value: 'No',
									type
								});
							} else {
								formData[name] = vModelValue.trim();
								categorizedData[groupName].push({
									name,
									value: vModelValue.trim(),
									type
								});
							}
							break;
						case "file":
							try {
								if(vModelValue && vModelValue.length > 0){
									const attachments = vModelValue.map(file => file.url)
									formData[name] = attachments;
									const conversationFilesData = JSON.stringify(vModelValue.map(file => ({
										name: file.name,
										value: file.url
									})));

									categorizedData[groupName].push({
									name,
									value: conversationFilesData,
									type
								});
								}
							} catch(e) {
								console.log(e)
							}
							// fileList = vModelValue;
							break;
						case "date":
							if(vModelValue) {
								formData[name] = vModelValue
								categorizedData[groupName].push({
									name,
									value: vModelValue,
									type
								});
							}
							break;
						default:
							if(typeof(vModelValue) ==="string" && (!vModelValue || !vModelValue.trim())){
								break;
							} else {
								formData[name] = vModelValue;
								categorizedData[groupName].push({
									name,
									value: vModelValue,
									type
								});
							}
							break;
					}
				}
			}
			//add submitted status
			formData['isInitialFormSubmitted'] = true;
			let response = null
			const peopleProperties = categorizedData['People Data'];
			const conversationProperties = categorizedData['Conversation Data'];
			this.SAVE_SCENARIO_PRECHAT_PROPERTIES({ peopleProps: peopleProperties, conversationProps: conversationProperties })
			return { formData, fileList };
		},
		async savePrechatQualificationProps({ triggeredFrom }) {
			const { scenarioConversationProperties: conversationProps, scenarioPeopleProperties : peopleProps } = this;

			let response = null;
			if(peopleProps.length > 0) {
				const peoplePropsObj = {};
				peopleProps.forEach(person => peoplePropsObj[person.name] = person.value)
				
				if(this.personId) {
					await Lead.updateProperties(this.cookieId, peoplePropsObj, { appClientId: this.configuration.id });
					response =  await Person.updatePersonProperties({
						personId: this.personId,
						properties: peoplePropsObj,
						appClientId: this.configuration.id
					})
				} else {
					if(triggeredFrom === 'REGULAR_PRECHAT') {
						peoplePropsObj.isInitialFormSubmitted = true;
					}

					response =  await Lead.updateProperties(this.cookieId, peoplePropsObj, { appClientId: this.configuration.id });
				}
			}
			if(conversationProps.length > 0 && !this.isExternalHelpdesk) {
				const maxRetries = 20;
				for (let i = 0; i < maxRetries; i++) {
					try {
						const savedResponse =  await Conversation.updateConversationProperties({
							id: this.selectedConversation.id,
							properties: conversationProps,
						});
						if(savedResponse.status === 200) {
							break;
						}
					} catch (error) {
						// console.log(error)
						console.log("Retry count: ", i + 1)
						console.log(error.mesage)
					}
				}
			}
			
			if(response && response.data){
				this.SET_USER_PROPERTIES({ properties: response.data })
			}

			this.SAVE_SCENARIO_PRECHAT_PROPERTIES({ peopleProps: [], conversationProps: [] });
		},
		async sendFormSubmissionMessage(formData, data) {
			const { cookieId, tenantId } = this;
			const id = uuid();
			const createdAt = Date.now();
			const properties = [];
			const conversationProperties = {};
			const getStringifiedValue = (value, dataType) => {
				if(typeof value !== 'string') {
					return JSON.stringify({ formattedValue: value })
				}
				return value;
			}
			for(let propertyName in formData) {
				if(propertyName === 'isInitialFormSubmitted') continue;

				let property = data.fields[propertyName];
				let dataType = 'text'
				if(property) {
					dataType = property.type || dataType;
				}
				properties.push({ name: propertyName, value: getStringifiedValue(formData[propertyName], dataType), dataType });
				conversationProperties[propertyName] = getStringifiedValue(formData[propertyName], dataType);
			}
			const message =  {
				id: id,
				createdAt,
				cookieId,				
				conversationId: id,
				senderId: cookieId,
				type: CONVERSATION_MESSAGE_TYPE_TEXT,
				senderType: MESSAGE_FROM_CUSTOMER,
				mediaType: 'form',
				mediaFormValue: properties,
				mediaValue: `Chat on ${this.brandName}`,
			}
			const conversation = {
				id,
				createdAt,
				cookieId,
				tenantId,
				type: CONVERSATION_TYPE_MESSENGER,
				updatedAt: createdAt,
				lastMessageText: `Chat on ${this.brandName}`,
				lastMessageSenderId: message.senderId,
				lastMessageSenderType: message.senderType,
				message,
				subject: `Chat on ${this.brandName}`,
				conversationProperties: JSON.stringify(conversationProperties)
			};
			
			return { conversation, message };
		},

		async createFormSubmissionMessage(formData, conversationId, data) {
			const { cookieId, tenantId } = this;
			const id = uuid();
			const createdAt = Date.now();
			const properties = [];
			const getStringifiedValue = (value, dataType) => {
				if(typeof value !== 'string') {
					return JSON.stringify({ formattedValue: value })
				}
				return value;
			}
			for(let propertyName in formData) {
				if(propertyName === 'isInitialFormSubmitted') continue;
				let property = data.fields[propertyName];
				let dataType = 'text'
				if(property) {
					dataType = property.type || dataType;
				}
				properties.push({ name: propertyName, value: getStringifiedValue(formData[propertyName], dataType), dataType })
			}
			const message =  {
				id: id,
				createdAt,
				cookieId,				
				conversationId,
				senderId: cookieId,
				type: CONVERSATION_MESSAGE_TYPE_TEXT,
				senderType: MESSAGE_FROM_CUSTOMER,
				mediaType: 'form',
				mediaFormValue: properties,
				mediaValue: `Chat on ${this.brandName}`,
			}
			
			return { message };
		},

		async createConversationAfterSubmitForm({ conversation, message }) {
			//Add appclientid to the conversation.
			conversation.appClientId = this.configuration.id;
			this.dummyConversationCreatedAt = message.createdAt;
			//add to the dom
			this.handleNewConversationAdded({ ...conversation, message: { ...message, isDirty: true } });
			//send to the agent
			//this.socket.emit(eventTypes.NEW_CONVERSATION_STARTED, conversation);
			this.isConversationStillBeingCreated = true;
			let isArchived = false;
			//store in db
			if(this.richpanelData.sid) {
				conversation.sessionId = this.richpanelData.sid;
			}
			const result = await Conversation.createConversation(conversation);
			this.handleAssignmentAfterCreatingConversation(result)
			conversation.createdAt = result.createdAt;
			conversation.updatedAt = result.createdAt;
			if(result && result.isArchived){
				isArchived = result.isArchived
			}
			if(!isArchived) {
				//pending messages queue
				await this.creatAllPendingMessages()
			}
			Vue.set(this.messagesDB, message.id, { ...message, isDirty: false });
			this.isConversationStillBeingCreated = false;
			return { isArchived };
		},
		async sendReplyTimeMessageIfNeeded(conversationId) {
			if(this.replyTime) {
				const successMessage = await this.getSuccessMessage();
				return await this.sendOperatorMessageInterface({ conversationId, mediaValue: successMessage});
			}
			return;
		},
		//Bot related starts
		areContactDetailsAlreadyAvialable(){
			const { email, phone } = this.properties;
			if(email && phone) return { status: true, noDataFor:[]};
			if(!email && !phone) return { status: false,  noDataFor:[{ name:'email' }, { name: 'phone' }] }
			if(!email) return { status: false,  noDataFor:[{ name:'email' }] }
			if(!phone && this.contactDetails.askFor === 'email-and-phone') return { status: false,  noDataFor:[{ name:'phone' }] }
			return { status: true, noDataFor:[] };
		},
		// This is last option
		// Inside this we will check whether this option 
		// is active or not if active ask for qualification details
		// otherwise end the flow.
		async askingQulificationDetails( conversationId ) {
			const { cookieId, tenantId } = this;
			const TIME_OUT = 500;

			if (this.qualification.isActive) {
				let properties = this.qualification.properties;
				if (properties && Array.isArray(properties) && properties.length > 0) {
					properties = properties.map(({ propertyName, groupName = "People Data" }) => {
						return { name: propertyName, groupName };
					})
					properties = properties.filter(({ name }) => {
						return !this.properties[name]
					});
					if(properties.length <=0) {
						await this.sendFlowEndMessages({ conversationId: conversationId })
						return
					}
					await delay(TIME_OUT);

					await this.sendMessage({
						conversationId,
						message: {
							id: uuid(),
							createdAt: Date.now(),
							cookieId,
							tenantId,
							conversationId,
							senderId: 'operator',
							type: CONVERSATION_MESSAGE_TYPE_TEXT,
							senderType: MESSAGE_FROM_OPERATOR,
							mediaType: MEDIA_TYPE_TEXT,
							mediaValue: this.$t('botMessages.FEW_MORE_DETAILS')
						}
					});

					await delay(TIME_OUT);
					await this.sendMessage({
						conversationId,
						message: {
							id: uuid(),
							createdAt: Date.now(),
							cookieId,
							tenantId,
							conversationId,
							senderId: 'operator',
							type: CONVERSATION_MESSAGE_TYPE_TEXT,
							senderType: MESSAGE_FROM_OPERATOR,
							mediaType: 'form',
							mediaFormValue: properties,
							mediaValue: QUALIFY_LEADS_FORM,
							isDone: false
						}
					});
					this.$once(QUALIFY_LEADS_FORM, async () => {
						await this.sendFlowEndMessages({ conversationId: conversationId })
					})
				}
			}
			else {
				//sending flow end messages
				//Qualification details are not active so end the flow
				await this.sendFlowEndMessages({ conversationId: conversationId })
			}
		},
		// This is last before option
		// Inside this we will check whether this option 
		// is active or not if active ask for contact details
		// otherwise go into qualification details flow.
		async askingContactDetails ( conversationId ) {
			const TIME_OUT = 500;
			const { cookieId, tenantId } = this;
			const ID = uuid();
			const { askFor } = this.contactDetails;

			await delay(TIME_OUT);
			await this.sendMessage({
				conversationId,
				message: {
					id: uuid(),
					createdAt: Date.now(),
					cookieId,
					tenantId,
					conversationId,
					senderId: 'operator',
					type: CONVERSATION_MESSAGE_TYPE_TEXT,
					senderType: MESSAGE_FROM_OPERATOR,
					mediaType: MEDIA_TYPE_TEXT,
					mediaValue: this.$t('botMessages.GIVE_THE_TEAM_WAY_TO_REACH_YOU')
				}
			});

			await delay(TIME_OUT);

			if (askFor) {
				let fields = this.properties.email ? [] : [{ name: 'email' }];
				if (askFor === 'email-and-phone' && !this.properties.phone) {
					fields.push({ name: 'phone' });
				}

				await this.sendMessage({
					conversationId,
					message: {
						id: ID,
						createdAt: Date.now(),
						cookieId,
						tenantId,
						conversationId,
						senderId: 'operator',
						type: CONVERSATION_MESSAGE_TYPE_TEXT,
						senderType: MESSAGE_FROM_OPERATOR,
						mediaType: MEDIA_TYPE_FORM,
						mediaFormValue: fields,
						mediaValue: CONTACT_DETAILS_FORM,
						isDone: false
					}
				});
			}
				
			this.$once('messageEmailSubmitted', async message => {
				if (ID !== message.id) return;
				await this.askingQulificationDetails(conversationId)
			});
		},
		//Algo :
		/**
		 * 1. User Type check
		 * 2. Routing is Active check to ask for customer or not ->After this goto 3
		 * 3. Contact details Check to ask for contact details -> After this goto 4
		 * 4. Qualification Details check -> THE END OF FLOW
		 */
		async beginOperatorWhenConversationStarts(conversationId) {
			//No bot for the logged in user as of now
			if(this.properties.type === TYPE_USER) {
				await this.sendFlowEndMessages({ conversationId })
				return ;
			}
			

			//required data for the bot messages
			const { cookieId, tenantId } = this;
			const TIME_OUT = 500;
			const A_CUSTOMER_LABEL = this.$t('botMessages.YES_EXISITING_CUSTOMER');
			const NOT_A_CUSTOMER_LABEL = this.$t('botMessages.NO_EXISITING_CUSTOMER');

			// Order is important (check configuration in helpdesk)
			// 1. replyTime
			// 2. routing
			// 3. contactDetails
			// 4. qualification

			setTimeout(async () => {
				//After user replying for the option question
				//Following will be triggered
				/*
				Algo:
				1. If answer is CUSTOMER and routing is active proceed the routing type
				2. contact details active && contact details are not avialble 
							2.1 If Yes => Ask for contact details
							2.2 If No  => Ask for qulification details 
				*/
				const areYouAnExisitingCustomer = async (option) => {
					if (option === A_CUSTOMER_LABEL) {

						const { routingType, routingTo } = this.routing;

						if (routingType === 'assignment') {
							if(!this.helpcenterStatus || !this.selectedConversation.assignee || !this.selectedConversation.assignee === 'unassigned') {
								// await this.setConversationAssignee(this.selectedConversation, routingTo, 'operator');
							}
						} else if (routingType === 'close') {
							await this.setConversationStatus(this.selectedConversation, 'CLOSED', 'operator', false);
						}
					}
					if (this.contactDetails.isActive && !this.areContactDetailsAlreadyAvialable().status) {
						await this.askingContactDetails(conversationId);
					}
					else {
						//Sending flow end messages
						//Contact details is not acitve so check for qualification details
						await this.askingQulificationDetails(conversationId)
					}
				}
				if (this.routing.isActive) {
					await delay(TIME_OUT);
					if(this.properties.areYouAnExistingCustomer) {
						//if this question is already answered move forward
						// console.log(this.properties)
						await areYouAnExisitingCustomer(this.properties.areYouAnExistingCustomer);
					}
					else {
						const options = [
							A_CUSTOMER_LABEL,
							NOT_A_CUSTOMER_LABEL	
						];

						const ID = uuid();
						await this.sendMessage({
							conversationId,
							message: {
								id: ID,
								createdAt: Date.now(),
								cookieId,
								tenantId,
								conversationId,
								senderId: 'operator',
								type: CONVERSATION_MESSAGE_TYPE_TEXT,
								senderType: MESSAGE_FROM_OPERATOR,
								mediaType: MEDIA_TYPE_TEXT,
								mediaValue: this.$t('botMessages.EXISITING_CUSTOMER'),
								options
							}
						});
						this.$once('messageOptionSelected', async ({ message, option }) => {
						if (ID !== message.id) return;
							areYouAnExisitingCustomer(option)
						});
					}
				}
				else if (this.contactDetails.isActive) {
					if(!this.areContactDetailsAlreadyAvialable().status) {
						// Contact details not availble and they are needed 
						// So ask contact details
						await this.askingContactDetails(conversationId);
					}
					else {
						// Contact details are already available
						// So check for qualification details logic
						await this.askingQulificationDetails(conversationId)
					}

				}
				else {
					// This is last option
					// Inside this we will check whether this option 
					// is active or not if active ask for qualification details
					// otherwise end the flow.
					await this.askingQulificationDetails(conversationId)
				}
				

			}, TIME_OUT);
		},
		async closeChat() {
			this.closingChat = true;
			try {
				await this.setConversationStatus(this.selectedConversation, 'CLOSED', 'customer', true);
			} catch(e){
				console.log(e)
			}
			this.closingChat = false;
		},
		//Bot related ends
		async sendMessage({ message, conversationId }, typing=true) {
			if(typing && message.senderType === MESSAGE_FROM_OPERATOR) 
				this.triggerBotTyping(conversationId)
			await this.broadcastMessage(message);
			await this.handleNewMessageAdded({ conversationId, message });
			const {
				mediaValue,
				mediaType,
				createdAt,
				senderId,
				senderType, } = message;
			await this.updateConversatonLastMessageAndTime(
				conversationId, 
				{
					text: this.computeLastMessageTextFromDifferentMessageMediaTypes({ value: mediaValue, type: mediaType }),
					time: createdAt,
					lastMessageSenderId: senderId,
					lastMessageSenderType: senderType,
				}
			);
			if(message.senderId === MESSAGE_FROM_OPERATOR) {
				let conversation = this.conversationsDB[conversationId];
				const latestCount = conversation.userUnReadMessagesCount ?  conversation.userUnReadMessagesCount+ 1 : 1;
				if(conversation) {
					const updatedData = {
						id: conversationId,
						userUnReadMessagesCount: latestCount,
						tenantId: this.tenantId,
						cookieId: this.cookieId
					}
					this.socket.emit(eventTypes.USER_UNREAD_MESSAGES_COUNT_CONVERSATION, updatedData)
				}
			}
		},

		checkIfMessengerShouldBeActiveByUserType() {
			if(this.isItFullScreen) {
				return this.isMessengerVisible;
			}
			const {
				showMessengerToAllLeads,
				showMessengerToAllUsers,
				displayTimeType,
				displayUserType
			} = this.control;
			const hostData = this.$root.hostData;
			


			//backword compatility
			// if (!showMessengerToAllLeads  && this.properties.type === TYPE_LEAD) {
			// 	this.isMessengerVisible = false;
			// } else if (!showMessengerToAllUsers && this.properties.type === TYPE_USER) {
			// 	this.isMessengerVisible = false;
			// }

			if (displayUserType && displayUserType === 'only-visitors' && this.properties.type !== TYPE_LEAD) {
				this.isMessengerVisible = false;
			} else if (displayUserType && displayUserType === 'only-customers' && this.properties.type !== TYPE_USER) {
				this.isMessengerVisible = false;
			}


			//advanced visibility settings
			// this.isMessengerVisible = this.isMessengerVisible && (this.isItFullScreen ||);
			// Get business hours and display messenger according 
			if(displayTimeType && displayTimeType === 'during-business-hours') {
				let availability = getNextAvailableTime(DateTime, this.getAgentTimeZoneOffset, this.availability, this.$root.defaultLanguage)
				if(!availability.isItWorkingHour) {
					this.isMessengerVisible = false;
				}
			}
			if(!canISeeMessenger({ ...this.control, hostData }).status) {
				this.isMessengerVisible = false;
			}
			this.checkIfMessengerIsNotVisible()
			return this.isMessengerVisible;
		},

		handleAgentTyping(conversationId) {
			if (conversationId === this.selectedConversationId) {
				if (this.isUserTyping) {
					clearTimeout(this.userTypingTimeoutId);
				} else {
					this.isUserTyping = true;
				}

				this.userTypingTimeoutId = setTimeout(() => {
					this.isUserTyping = false;
				}, 5000)
			}
		},
		triggerBotTyping(conversationId) {
			if(this.userTypingTimeoutId) {
				clearTimeout(this.userTypingTimeoutId);
			}
			this.typingUserId = null;
			this.isUserTyping = !this.isUserTyping;
			if(this.isUserTyping) {
				this.typingUserId == MESSAGE_FROM_OPERATOR;
			}
		},

		async syncWithServer(richpanelSettings) {
			let settings = { ...this.richpanelData }

			if(richpanelSettings) {
				settings = richpanelSettings
			}
			if(!settings.user_properties) {
				settings.user_properties = this.richPanelAuthData || null
			}
			await this.SYNC(settings);
		},

		handleOnConversationMessagesScroll(flag) {
			//for now let's remove the animation and full header
			//this.isheaderOpen = flag
		},	

		addNewMessage({ conversationId, message }) {
			//incase if typing is still going on stop 
			//the typing activity forcefully and add the new message
			if(this.isUserTyping) {
				this.triggerBotTyping() //this stop the typing activity
			}
			if (!this.conversationMessagesMap[conversationId]) {
				Vue.set(this.conversationMessagesMap, conversationId, []);
			}
			const conversationMessages = this.conversationMessagesMap[conversationId];
			if (message.id in this.messagesDB) {
				Vue.set(this.messagesDB, message.id, { ...message, isDirty: false });
				if(!conversationMessages.includes(message.id)){
					conversationMessages.push(message.id);
				}
			} else {
				conversationMessages.push(message.id);
				Vue.set(this.messagesDB, message.id, message);
				const {
					mediaType,
					mediaValue,
					createdAt,
					senderId,
					senderType, } = message;
				this.updateConversatonLastMessageAndTime(
					conversationId,
					{
						text: this.computeLastMessageTextFromDifferentMessageMediaTypes({ type: mediaType, value: mediaValue }),
						time: createdAt,
						lastMessageSenderId: senderId,
						lastMessageSenderType: senderType,
					}
				)
			}
		},

		async handleNewConversationAdded(conversation) {
			const { id, createdAt, message } = conversation;
			if (!(id in this.conversationsDB)) {
				Vue.set(this.conversationsDB, id, conversation);
				this.conversationIds.unshift(id);
			}

			const { dummyConversationCreatedAt, isInScreenConversation } = this;
			if (isInScreenConversation) {
				if (createdAt === dummyConversationCreatedAt) {
					this.addNewMessage({ conversationId: id, message });
					this.selectedConversationId = id;
				}
			}
			this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false })
		},
		//for messenger trigger
		sendMessageToParentWindow({ shrinkMessenger = true }) {
			this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false, shrinkMessenger });
		},
		//for notifications 
		sendMessageToParentWindowAboutNotifications({ isItForImagePreview = false, actionName, payload, shrinkMessenger = true }) {
			const hasNotifications = this.newInAppMessages.length>0 || this.newConversationMessages.length > 0 || this.showGreetingAnimation;
			const hasPopupNotifications = isItForImagePreview ? isItForImagePreview : this.newInAppPopupTypeMessages.length > 0;
			let heightOfNotifications = 0;
			if(this.sendNotifierTimeOut) {
				clearTimeout(this.sendNotifierTimeOut)
			}
			this.sendNotifierTimeOut = setTimeout(()=>{
				if(hasNotifications) {
				try {
					document.querySelectorAll('.preview-for-message').forEach((notification) => {
						notification.style.width = 'max-content';
						heightOfNotifications += notification.clientHeight;
						notification.style.width = '100%';
					})
				} catch(e) {
					console.log(e)
				}	
			}
			const richpanel_messenger_value =  this.isOpened;
			// console.log(heightOfNotifications)
			let postMessage = { hasNotifications, hasPopupNotifications, heightOfNotifications, richpanel_messenger_value, isMessengerVisible: this.isMessengerVisible }
			if(actionName) {
				postMessage.actionName = actionName;
			}
			if(payload) {
				postMessage.payload = payload;
			}
			parent.postMessage(postMessage, '*')
			}, 0)
		},

		handleNewMessageAdded({ conversationId, message }) {
			this.addNewMessage({ conversationId, message });
		},

		updateConversatonLastMessageAndTime(id, { text, time, lastMessageSenderType, lastMessageSenderId }) {
			const conversation = this.conversationsDB[id];
			if (conversation) {
				Vue.set(conversation, 'lastMessageText', text);
				Vue.set(conversation, 'lastMessageTime', time);
				Vue.set(conversation, 'updatedAt', time);
				Vue.set(conversation, 'lastMessageSenderType', lastMessageSenderType);
				Vue.set(conversation, 'lastMessageSenderId', lastMessageSenderId);
			} else throw new Error('Conversation does not exist for id', id);
		},

		handleAfterMessagesLoaded({ id, messages }) {
			if (messages instanceof Array) {
				messages.forEach(message => {
					if(message.mediaType === MEDIA_TYPE_RATING && !message.mediaFormValue) {
						message.mediaFormValue = [{
							name: 'feedback',
							value: null,
						}]
					}
					this.addNewMessage({ conversationId: id, message });
				})
			}
			
			this.areMessagesLoading = false;
		},

		async loadMessages(id) {
			this.areMessagesLoading = true;
			await this.loadMessagesOfConversation({ id })
		},

		async loadMessagesOfConversation({ id }) {
			const messages = await Message.getMessages({ conversationId: id });
			this.handleAfterMessagesLoaded({ id, messages });
		},

		async loadConversations() {
			try {
				this.areConversationsLoading = true;
				let onlyForCurrentDevice = this.isUserLoggedIn() ? false : true;
				const conversations = await Conversation.getConversations({ cookieId: this.cookieId, onlyForCurrentDevice, brandId: this.brandId, appClientId: this.configuration.id });
				this.handleAfterConversationsLoaded(conversations);
				this.areConversationsLoading = false;
			} catch(e) {
				console.log(e);
				this.areConversationsLoading = false;
			}
		},

		handleAfterConversationsLoaded(conversations) {
			if (conversations instanceof Array) {
				const conversationsDB = this.conversationsDB
				conversations.forEach(conversation => {
					if(conversation.lastMessageText){
						try {
							conversation.lastMessageText = this.translateLastMessageText({ lastMessageText: conversation.lastMessageText })
						} catch(e){
							console.error(e);
						}
					}
					Vue.set(this.conversationsDB, conversation.id, conversation)
					if(!this.conversationIds.includes(conversation.id)){
						this.conversationIds.push(conversation.id)
					}
				})
			}
			this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false })
		},

		handleOnTyping(text) {
			if (text) {
				const { cookieId, tenantId, selectedConversationId } = this;
				this.socket.emit(
					eventTypes.CUSTOMER_TYPING,
					{ cookieId, tenantId, conversationId: selectedConversationId }
				)
			}
		},

		changeStateOfMessenger(conversationId, screenType) {
			this.selectedConversationId = conversationId;
			this.screenType = screenType;
		},
		async handleNewMessageClick({ conversation, actionType }) {
			if(actionType === 'open') {
				this.isOpened = true;
				this.sendMessageToParentWindow({})
				this.fetchDataForAllCards({ rerouteAfterLoading: 'NO_WHERE' })
				await this.handleConversationClick(conversation)
			}
			else
				await this.clearUnReadMessages(conversation.id)
			this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false })
		},
		handleRecentConversationClick(conversation) {
			this.navigatedFrom = 'HOME';
			this.handleConversationClick(conversation);
		},
		async handleConversationClick(conversation) {
			await this.SET_SELECTED_CONVERSATION(conversation);
			const { id } = conversation;
			this.changeStateOfMessenger(id, SCREEN_TYPE_CONVERSATION);

			if (!this.messagesDB[id]) {
				this.areMessagesLoading = true;
			};
			if(conversation.inAppMessageStatus === 'sent')
				await this.updateInAppMessageStatus({ inAppMessageId: id, status: 'delivered' });
			await this.loadMessages(id);
			//Clear unread messages count if there are any.
			if(conversation.userUnReadMessagesCount >=1) {
				await this.clearUnReadMessages(id);
			}
		},
		async handleOrderConversation(orderData) {
			this.handleChatClick(this.currentScenarioName, orderData, orderData.prechatFormData);
		},
		onChildClick(scenario, animationType="rightToLeft") {
			const { scenarioId, scenarioName, children } = scenario;
			this.addALoaderForScenarios();
		    this.getAnimation = animationType === "rightToLeft" ? ["animated","fast","fadeInRight"] : ["animated","fast","fadeInLeft"];
			this.screenType = this.screenTypes.SCREEN_HELP_AND_SUPPORT;
			this.breadCrumbHandler.push(scenario)
		},
		addALoaderForScenarios() {
			this.scenarioLoading = true;
			setTimeout(()=>{
				this.scenarioLoading = false;
			}, 500)
		},

		moveToScenario(scenario) {
			this.handleBreadCrumbClick(scenario)
		},

		handleBreadCrumbClick(scenario) {
			this.navigatedFrom = 'BREADCRUMB'
			const {
				scenarioId,
			} = scenario;
			if(scenarioId === 'HOME' ) {
				this.onBackButtonClick();
				this.breadCrumbHandler = [];
				return;
			}
			let currentClickedIndex = this.breadCrumbHandler.findIndex((breadCrumb) => breadCrumb.scenarioId === scenarioId);
			let fulScenario = JSON.parse(JSON.stringify(this.breadCrumbHandler[currentClickedIndex]))
			this.breadCrumbHandler = this.breadCrumbHandler.slice(0, currentClickedIndex);
			this.onChildClick(fulScenario, 'leftToRight')
		},

		async handleChatClick(scenarioName, orderInformation, prechatFormData=null) {
			let orderData = orderInformation;
			const { routingTo } = this.routing;
			const currentScenario = this.currentScenario;
			let breadCrumbsWithoutStaticFields = [];
			const breadCrumbInfo = []
			if(currentScenario.blockType === 'ORDER'){
				breadCrumbsWithoutStaticFields = this.breadCrumbHandler.slice(4);
				breadCrumbInfo.push(this.$t('orderList.orderLabel'));
			} else {
				breadCrumbsWithoutStaticFields = this.breadCrumbHandler.slice(2);
				breadCrumbInfo.push(this.helpAndSupportLabel);
			}

			breadCrumbsWithoutStaticFields.forEach((scenario) => {
				breadCrumbInfo.push(scenario.scenarioName)
			})

			this.changeStateOfMessenger("", SCREEN_TYPE_CONVERSATION);
			if(currentScenario) {
				const mediaFormValue = [
					{
						name: 'scenarioBreadcrumb',
						value: JSON.stringify(breadCrumbInfo),
						dataType: 'breadcrumb'
					}
				]
				await this.handleOnEnterNewMessage({
					type: MEDIA_TYPE_JOURNEY,
					value: currentScenario.scenarioName,
					mediaFormValue: mediaFormValue,
					scenarioName: currentScenario.scenarioName,
					scenarioId: currentScenario.scenarioId,
					tagIds: currentScenario.tagIds,
				});
			}

			if(!orderData && currentScenario.blockType === 'ORDER') {
				orderData = {
					orderInfo: this.orderDetails,
					selectedProucts: [],
					quantities: {},
				}
			}
			if(prechatFormData){
				await this.handleScenarioPreChatFormSubmit(prechatFormData)
			}
			if(orderData) {
				let orderInfo = orderData.orderInfo;
				let selectedProducts = orderData.selectedProucts;
				let quantities = orderData.quantities;
				const getSelectedItemsInfo = (selectedProductsOfOrder) => {
					let items = [];
					for(let product of selectedProductsOfOrder) {
						let productInfo = orderInfo.products.find((pr)=>pr.id+':'+pr.productId === product);
						let {
							name,
							productId,
							price,
						} = productInfo;
						const item = {
							itemId: productInfo.id,
							itemLabel: name, 
							calculatedPrice: price * quantities[productInfo.id+':'+productInfo.productId],
							selectedCount: quantities[productInfo.id+':'+productInfo.productId],
							productId
						}
						items.push(item)
					}
					return items;
				}
				const orderMessageStruct = {
					storeLogoURL: 'https://s3-us-west-2.amazonaws.com/app.richpanel.com/static/images/datasources/f9be7eab-7be9-4d19-ab7f-c0b818b408f4-logo.png',
					orderLabel: 'Order',
					orderId: orderInfo.orderNumber,
					status: orderInfo.status,
					currency: orderInfo.currency || '$',
					orderDbId: orderInfo.id,
					appClientId: orderInfo.appClientId,
					amount: {
						label: 'AMT',
						value: orderInfo.amount,
					},
					qty: {
						label: 'ITEMS',
						value: orderInfo.products ? orderInfo.products.length : 0,
						measureLabel: 'items'
					},
					selectedItems: {
						header: 'Selected items',
						items: getSelectedItemsInfo(selectedProducts)
					},
				}
				await this.handleOnEnterNewMessage({
					type: MEDIA_TYPE_ORDER,
					value : JSON.stringify(orderMessageStruct)
				})
			}
			const { selectedConversationId } = this
			this.beginOperatorWhenConversationStarts(selectedConversationId)
			if (currentScenario.assigneeId && currentScenario.assigneeId !== "unassigned") {
				await Promise.all([
					this.setConversationAssignee(this.selectedConversation, currentScenario.assigneeId, 'operator'),
					Conversation.runAutomationRule({ 
						conversationId: selectedConversationId,
						canExecuteForScenarios: true,
						canDoAgentAssignment: false
					})
				])
			} else {
				await Conversation.runAutomationRule({ conversationId: selectedConversationId, canExecuteForScenarios: true, });
				// if(this.routing.isActive && this.routing.routingType === 'assignment') {
				// 	await this.setConversationAssignee(this.selectedConversation, routingTo, 'operator');
				// }
			}


			if(currentScenario && currentScenario.priority && currentScenario.priority === 'HIGH' ){
				await Conversation.updateConversationPriority({ id: selectedConversationId , priority: currentScenario.priority.toUpperCase(), operatorId: 'operator' })
			}
		},

		onBackButtonClick(goTo = SCREEN_TYPE_START) {
			this.changeStateOfMessenger('', goTo);

			if (goTo === this.screenTypes.SCREEN_TYPE_START) {
				this.changeAninamtion = true;
			}
			if(this.breadCrumbHandler.length) {
				this.breadCrumbHandler = [];
			}
			this.navigatedFrom = '';
			this.orderDetails = null;
		},
		computeLastMessageTextFromDifferentMessageMediaTypes({ type, value }) {
			switch(type) {
				case MEDIA_TYPE_GIF:
					return this.$t('lastMessageText.sentAGif');
				case MEDIA_TYPE_TEXT:
					return value;
				case MEDIA_TYPE_STICKER:
					return value;
				case MEDIA_TYPE_FILE:
					return this.$t('lastMessageText.sharedFile');
				case MEDIA_TYPE_FORM:
					return this.$t('lastMessageText.askedForQualificationDetails');
				case MEDIA_TYPE_RATING:
					return this.$t('lastMessageText.askedForRating');
				case MEDIA_TYPE_RATING_FORM:
					return this.$t('lastMessageText.askedForFeedback');
				case MEDIA_TYPE_ORDER:
					return this.$t('lastMessageText.sharedOrderSummary');
				case MEDIA_TYPE_JOURNEY:
					return value;
				default:
					throw new Error('Media Type not defined', type);
			}
		},
		translateLastMessageText({ lastMessageText }) {
			switch(lastMessageText) {
				case 'Sent a GIF':
					return this.$t('lastMessageText.sentAGif');
				case 'Shared a file':
					return this.$t('lastMessageText.sharedFile');
				case 'Asked for qualification details.':
					return this.$t('lastMessageText.askedForQualificationDetails');
				case 'Asked for rating':
					return this.$t('lastMessageText.askedForRating');
				case 'Asked for feedback':
					return this.$t('lastMessageText.askedForFeedback');
				case 'Shared order summary':
					return this.$t('lastMessageText.sharedOrderSummary');
				default:
					return lastMessageText;
			}
		},

		async broadcastMessage(message) {
			if(message.type == 'text' && message.mediaType === 'text') {
				try {
					message.mediaValue = message.mediaValue.replace(/\b(?:\d{4}[ -]?){3}(?=\d{4}\b)/g, '**** **** **** ');
				} catch(e){
					console.log(e)
				}
			}
			message.channel = CONVERSATION_TYPE_MESSENGER;
			let messageResponse = await Message.createMessage(message);
			message.createdAt = messageResponse.createdAt;
			message.updatedAt = message.createdAt;
			this.socket.emit(
				eventTypes.CONVERSATION_NEW_MESSAGE_ADDED,
				message
			);
		},

      async handleOnEnterNewMessage({ type, value, scenarioId = '', scenarioName = '', tagIds, mediaFormValue = [] }, messageObj = null, prechat = false) {
			const { selectedConversation, conversations, cookieId, tenantId } = this;
			const createdAt = Date.now()+29762;
			const lastMessageTextCalculated = this.computeLastMessageTextFromDifferentMessageMediaTypes({ type, value });
			
			let playPromise = messageSentAudio.play();
			playPromise.catch(() => {})
			if(type == 'text') {
					try {
						value = value.replace(/\b(?:\d{4}[ -]?){3}(?=\d{4}\b)/g, '**** **** **** ');
					} catch(e){
						console.log(e)
					}
				}
			if (selectedConversation && (selectedConversation.isInAppMessage !== 'yes' || !['delivered', 'read'].includes(selectedConversation.inAppMessageStatus))) {
				const { id, status, assignee } = selectedConversation;
				let message = {}
				if(messageObj) {
					message = messageObj
				} else {
					message = {
						id: uuid(),
						createdAt,
						cookieId,
						tenantId,
						conversationId: id,
						senderId: cookieId,
						type: CONVERSATION_MESSAGE_TYPE_TEXT,
						senderType: MESSAGE_FROM_CUSTOMER,
						mediaType: type,
						mediaValue: value,
						isDirty: true
					};
				}
				
				this.handleNewMessageAdded({ conversationId: id, message });

				if (type === MEDIA_TYPE_FILE && !prechat) {
					const Key = await File.upload(value);
					if (!Key) {
						return;
					}
					message['mediaValue'] = Key;
				}

				if(type === MEDIA_TYPE_JOURNEY && mediaFormValue.length) {
					message['mediaFormValue'] = mediaFormValue
				}

				if(this.isConversationStillBeingCreated){
					this.messageQueue.push({...message});
				}
				else{
					await this.broadcastMessage(message)
				}

				this.updateConversatonLastMessageAndTime(id, {
					text: lastMessageTextCalculated,
					time: createdAt,
					lastMessageSenderId: message.senderId,
					lastMessageSenderType: message.senderType,
				});

			} else {
				const id = uuid();
				const newMessage = {
					conversationId: id,
					id,
					type: CONVERSATION_MESSAGE_TYPE_TEXT,
					senderId: cookieId,
					senderType: MESSAGE_FROM_CUSTOMER,
					createdAt,
					mediaType: type,
					mediaValue: value
				}
				let message = newMessage;
				let lastMessageText = lastMessageTextCalculated;
				let assignee = '';
				let tags = tagIds;
				let subject = scenarioId ? striptags(message.mediaValue) : `Chat on ${this.brandName}`;
				//if it is inAppMessage Keep the first message as InAPP message
				if (selectedConversation && ['delivered', 'read'].includes(selectedConversation.inAppMessageStatus)) {
					message = this.currentMessages[0];
					message.id = id;
					message.conversationId = id,
					lastMessageText = selectedConversation.lastMessageText;
					subject = selectedConversation.subject || subject;
					if(message.hasOwnProperty('displayImage')) {
						delete message.displayImage;		
					}
					assignee = selectedConversation.assignee
				}
				else {
					//handle files
					if (type === MEDIA_TYPE_FILE) {
						const Key = await File.upload(value);
						if (!Key) {
							return;
						}
						message['mediaValue'] = Key;
					}

					if(type === MEDIA_TYPE_JOURNEY && mediaFormValue.length)  {
						message['mediaFormValue'] = mediaFormValue
					}
				}
				const conversation = {
					id,
					createdAt,
					cookieId,
					tenantId,
					type: CONVERSATION_TYPE_MESSENGER,
					updatedAt: createdAt,
					lastMessageText,
					lastMessageSenderId: message.senderId,
					lastMessageSenderType: message.senderType,
					message,
					subject,
					assignee,
					scenarioId,
                    scenarioName,
					tags,
					appClientId: this.configuration.id
				}
				if(message.hasOwnProperty('displayImage')) {
					delete message.displayImage;		
				}
				if(message.hasOwnProperty('isDirty')){
					delete message.isDirty;
				}
				this.dummyConversationCreatedAt = createdAt;
				this.handleNewConversationAdded({ ...conversation, message: { ...message, isDirty: true } });
				
				//this.socket.emit(eventTypes.NEW_CONVERSATION_STARTED, conversation);
				this.isConversationStillBeingCreated = true;
				if (selectedConversation && ['delivered', 'read'].includes(selectedConversation.inAppMessageStatus)) { 
					await this.handleOnEnterNewMessage({ type, value })
				}
				if(this.richpanelData.sid) {
					conversation.sessionId = this.richpanelData.sid;
				}
				const result = await Conversation.createConversation(conversation);
				conversation.createdAt = result.createdAt;
				conversation.updatedAt = result.createdAt;
				message.createdAt = result.createdAt;
				message.updatedAt = result.createdAt;
				this.isConversationStillBeingCreated = false;

				this.handleAssignmentAfterCreatingConversation(result)
				Vue.set(this.messagesDB, message.id, { ...message, isDirty: false });

				if(!result.isArchived) {
					await this.creatAllPendingMessages()
					if (selectedConversation && ['delivered', 'read'].includes(selectedConversation.inAppMessageStatus)) {
						await this.updateInAppMessageStatus({ inAppMessageId: selectedConversation.id, status: 'convertedToConversation' })
						this.conversationIds.splice(this.conversationIds.indexOf(selectedConversation.id), 1)
						Vue.delete(this.conversationsDB, selectedConversation.id)
						await this.handleTheUserReplyForInAppMessage({ type, value, id })
					}
					else {
						if(!scenarioId) {
							//if it's scenario bot will be triggered after sending all the related messages of that scneario
							//Like 1. Prechat forms, 2. Order card(with or with out selected items)
							this.beginOperatorWhenConversationStarts(id);
						}
					}
				} else {
					Vue.set(this.messagesDB, message.id, { ...message, isDirty: false });
				}
			}
		},

		async handleTheUserReplyForInAppMessage({ type, value, id }) {
			this.beginOperatorWhenConversationStarts(id);
		},

		async creatAllPendingMessages() {
			for(let message of this.messageQueue){
				await this.broadcastMessage(message)
			}
			this.messageQueue = [];
		},

		async handleInAppMessageNotificationClick({ actionType, inAppMessageId }) {
			switch (actionType) {
				case "open": {
					this.isOpened = true;
					this.sendMessageToParentWindow({})
					this.fetchDataForAllCards({ rerouteAfterLoading: 'NO_WHERE' })
					await this.handleConversationClick(this.conversationsDB[inAppMessageId])
				}
				case "close": {
					await this.updateInAppMessageStatus({ inAppMessageId, status: 'delivered' });
				}
			}
			this.emptyAllInAppMessages(); //will temporarly change the in app popup messags to chat
			this.sendMessageToParentWindowAboutNotifications({ isItForImagePreview: false });
		},

		animateTrigger() {
			if(this.showGreetingAnimation) {
				setTimeout(()=>{
					this.showGreetingAnimationMessage = false;
					if(this.showGreetingAnimation) {
						this.showGreetingAnimationEnd = true;
						setTimeout(()=> {
							this.showGreetingAnimationEnd = false;
						}, 700)
						setTimeout(()=> {
							if(!this.isOpened) {
								this.isSyncingInProcess = true;
							}
							setTimeout(()=> {
								if(this.isSyncingInProcess) {
									this.isSyncingInProcess = false;
								}
							}, 100)
						}, 700)
						setTimeout(()=> {
							this.showGreetingAnimation = false;
							setTimeout(()=>{
								this.sendMessageToParentWindow({})
							}, 700)
						}, 400)
					}
				}, 6000)
			}
			
		},

		async updateInAppMessageStatus({ inAppMessageId, status }) {
			const conversation = this.conversationsDB[inAppMessageId];
			conversation.inAppMessageStatus = status;
			Vue.set(this.conversationsDB, conversation.id, conversation)
			await Conversation.updateInAppMessageStatus( { id: inAppMessageId, status });
		},

		async loadScenarios() {
			try {
				if(this.isSupportScenarioAvailable || this.isOrderScenarioAvailable) {
					return;
				}
				this.scenariosDataLoading = true
				await this.FETCH_ALL_SCENARIOS(this.brandId);
				this.scenariosDataLoading = false
			} catch (e) {
				console.log("Error in fetching scenarios : ", e);
				this.scenariosDataLoading = false
			}
		},

		async fetchPersonId() {
			try {
				if(!this.isUserLoggedIn()) {
					//User not logged in 
					return;
				}
				this.loadingOrders = true;
				await this.FETCH_PERSON_ID({cookiedId: this.cookieId, tenantId: this.tenantId});
				this.sourcePersonId = this.personId;
				await Promise.all([
					this.fetchOrders(this.sourcePersonId),
					this.fetchCustomerProperties(this.personId || this.sourcePersonId)
				])
				this.loadingOrders = false;
			} catch (e) {
				console.log("Error in fetching source person : ", e);
				this.loadingOrders = false;
			}
		},

		async fetchCustomerProperties(personId) {
			try {
				await this.FETCH_CUSTOMER_DATA_BY_PERSON_ID({ personId });
			} catch (e) {
				console.log("Error in fetching customer properties person");
			}
		},

		async fetchOrders(sourcePersonId) {
			if(!sourcePersonId) {
				sourcePersonId = this.sourcePersonId;
			}
			try {
				let pageSize = 4;
				let page = (this.orders && this.orders.length) ? Math.floor((this.orders.length / pageSize)) + 1 : 1;
				if(!page) page = 1;
				await this.FETCH_ALL_ORDER_BY_UID({ personId: sourcePersonId, tenantId: this.tenantId, page, appClientId: this.configuration.id, offset: this.orders.length });
				this.allOrders = this.orders;
				
			} catch (e) {
 				console.log("Error in fetching orders : ", e);
			}
		},

		async onViewMoreOrders(sourcePersonId){
			this.loadingOrders = true;
			try {
				await this.fetchOrders(sourcePersonId)
				this.loadingOrders = false;
			} catch(e){
				this.loadingOrders = false;
			}
			
		},

		getScenarioAvailability(key) {
			if (this.scenarioList && Object.keys(this.scenarioList).length) {
				if (this.scenarioList.hasOwnProperty(key)) {
				return this.scenarioList[key].length > 0;
				} else {
				return false;
				}
			} else {
				return false;
			}
		},

		...mapActions({
			CREATE_CONV_EXTERNAL_HELPDESK: "CREATE_CONV_EXTERNAL_HELPDESK",
			FETCH_ALL_ORDER_BY_UID: 'FETCH_ALL_ORDER_BY_UID',
			FETCH_PERSON_ID: 'FETCH_PERSON_ID',
			FETCH_ALL_SCENARIOS: 'FETCH_ALL_SCENARIOS',
			SYNC: 'SYNC',
			GET_PROPERTIES_DATA: 'GET_PROPERTIES_DATA',
			FETCH_ALL_AGENT: 'FETCH_ALL_AGENT',
			FETCH_TEAM_DETAILS: 'FETCH_TEAM_DETAILS',
			SET_SELECTED_CONVERSATION: 'SET_SELECTED_CONVERSATION',
			SET_ACTIVE_AGENTS: 'SET_ACTIVE_AGENTS',
			SET_USER_PROPERTIES: 'SET_USER_PROPERTIES',
			UPDATE_AGENT_PROPERTIES:'UPDATE_AGENT_PROPERTIES',
			FETCH_CUSTOMER_DATA_BY_PERSON_ID: 'FETCH_CUSTOMER_DATA_BY_PERSON_ID',
			RESET_ORDERS_DATA: "RESET_ORDERS_DATA",
			SAVE_SCENARIO_PRECHAT_PROPERTIES: 'SAVE_SCENARIO_PRECHAT_PROPERTIES',
			GET_ORDER_SHIPPING_DETAILS: "GET_ORDER_SHIPPING_DETAILS",
			TRY_ORDER_LOGIN: "TRY_ORDER_LOGIN",
		}),

		switchToHomeScreen({
			closeMessenger = false
		}) {
			this.handleBreadCrumbClick({ scenarioId: 'HOME' })
			if(closeMessenger) {

				this.toggleMessengerOpen({})
			}
		}
	}
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:300,400,500,600,700');
//@import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css');
// @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,500i,600,700');
@import url("https://use.fontawesome.com/releases/v5.7.2/css/all.css");
.rp-messenger-help-and-support-response-text, .order-response-text {
	font-weight: 400;
	font-size: 17px;
	color: #000000;
	word-break: break-word;
	font-weight: normal; 
	line-height: 1.4;
	margin: 1em 0;
	@include for-size(desktop-up){
		font-size: 18px;
		line-height: 1.6;
	};
	&.suggestion-text{
		color: #4d4d4d;
		margin-top: 0px;
	}
	img, iframe {
		max-height: 100%;
		max-width: 100%;
		width: 100%;
	}
	iframe {
		min-height: 300px;
	}
	img, iframe, h1, h2, h3, h4, h5, h6, a, ul, ol{
		margin-top: 15px;
		margin-bottom: 0px;
	}

	p{
		margin: 0px;
	}

	p{
		margin: 0px;
	}

	h1, h2, h3, h4, h5, h6 {
		margin: none;
        margin: 0.8rem 0px;
		font-weight: 400;
		line-height: 1.3;
		text-transform: uppercase;
	}

	h1,h2,h3,h4,h5,h6 {
		font-size: 17px;
		color: #000000;
	}

	a {
		color: $color !important;
		&:hover{
			text-decoration: underline;
		}
	}
	ul {
		list-style: circle;
	}
	ul, ol {
		padding-top: 0px;
		padding-bottom: 0px;
	}
	ul, ol {
		li {
			margin: 5px 0px;
		}
	}
}
.rp-scenario-button-suggestion-text {
	text-align: center;
	margin: 20px 0px 30px 0px;
	color: #000;
}

.rp-scneario-text-button {
	color: #000 !important;
	text-decoration: underline;
	margin-top: 7px !important;
	.scenario-button-text {
		font-weight: 400 !important;
	}
}

.rp-scenario-buttons, .rp-scenario-content-ctaButtons {
	.uppercase-text{
		text-transform: uppercase;
		width: 360px;
		max-width: 100%;
	}
}
.rp-scenario-content-ctaButtons {
	max-width: 100%;
}
.rp-messenger-conversations-list__no-data {
	padding: 20px;
	@include for-size(tablet-landscape-up){
		padding: 40px
	}
	@include for-size(desktop-up){
		padding: 60px
	}
	display: flex;
	align-items: center;
	color: #333;
	font-style: italic;
	font-size: 13px;
	img, svg {
		margin-right: 1rem;
		height: 30px;
		width: 30px;
	}
	&.for-orders{
		padding: 20px;
		@include for-size(tablet-landscape-up) {
			padding: 40px;
		}
		@include for-size(desktop-up) {
			padding: 60px;
		}
	}
}
$size: 60px;

*,
*::after,
*::before {
	box-sizing: border-box;
}

.rp-app {
	font-weight: $fontWeight;
	color: $blackColor;
	position: relative;
	letter-spacing: .1px;
	font-family: $font;
	--livechat-widget-width: 375px;
	.el-badge__content{
		background-color: red !important;
		border: 1px solid #c78e8e;
	}
}
button {
	border-radius: 5px !important;
}

.rp-messenger-header {
	// background: $color;
	// background: $gradient;
	color: white;
	border-top-right-radius: 10px;
	border-top-left-radius: 10px;
	@include for-size(desktop-up){
		border-top-right-radius: 0px;
		border-top-left-radius: 0px;
	}
	@media only screen and (max-device-width: 480px) and (min-device-width: 320px){
		border-top-right-radius: 0px;
		border-top-left-radius: 0px;
	}
}

.rp-messenger-content {
	background: #fefefe;
	height: calc(100% - 76px);
	@include for-size(desktop-up){
		border-left: 1px solid #E6E5E6;
		border-right: 1px solid #E6E5E6;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}
	border-left: 1px solid #E6E5E6;
	border-right: 1px solid #E6E5E6;
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
	@media only screen and (max-device-width: 480px) and (min-device-width: 320px){
		border-bottom-left-radius: 0px;
		border-bottom-right-radius: 0px;
	}
}

textarea {
	border: none;
	resize: none;
	outline: none;
}

button {
	padding: 0;
	margin: 0;
	border: none;
	outline: none;
}

.rp-messenger {
	position: fixed;
	bottom: 103px;
	right: 20px;
	width: var(--livechat-widget-width);
	max-width: 100%;
	top: 20px;
	border-radius: 10px;
	overflow: auto;
	font-weight: $fontWeight;
	box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.1);
	@include flexColumn;
	// background: $color;
	// background: $gradient;
	&.start {
		// .el-loading-spinner {
		// 	top: 65%;
		// }
	}
	&.main-container-full-screen{
		width: 100% !important;
		top: 0px;
		height: 100%;
		right: 0px;
		left: 0px;
		bottom: 0px;
		border-radius: 0px !important;
		.rp-messenger-header {
			border-radius: 0px !important;
		}
	}
	.rp-messenger-inner {
		position: fixed;
		height: calc(100% - (145px + var(--theme-bottom-position)));
		width: var(--livechat-widget-width);
		max-width: 100%;
		font-weight: $fontWeight;
		border-radius: 10px;
		&.child-container-full-screen{
			align-self: center;
			height: 100%;
			overflow: auto;
			width: 100%;
			@include for-size(tablet-landscape-up){
				max-width: 100%;
				padding: 0 100px
			}
			@include for-size(desktop-up){
				max-width: 100%;
				padding: 0 250px
			}
			@media only screen 
				and (min-device-width: 320px) 
				and (max-device-width: 480px) {
					width: 100%;
				}
			@media only screen 
				and (min-device-width: 481px) 
				and (max-device-width: 720px) {
					width: 85%;
			}
		}
	}
	.rp-messenger-inner-screens {
		position: fixed;
		height: calc(100% - (104px + var(--theme-bottom-position)));
		width: var(--livechat-widget-width);
		max-width: 100%;
		font-weight: $fontWeight;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		&.child-container-full-screen-inner-screens {
			height: 100%;
			.rp-messenger-content {
				height: calc(100% - 75px);
			}
			align-self: center;
			height: calc(100% - 10px);
			overflow: auto;
			width: 900px;
			max-width: 100%;
			@include for-size(tablet-landscape-up){
				width: 100%;
				padding: 0 100px
			}
			@include for-size(desktop-up){
				max-width: 100%;
				padding: 0 250px
			}
			@media only screen 
				and (min-device-width: 320px) 
				and (max-device-width: 480px) {
					width: 100%;
					height: calc(100%);
				}
			@media only screen 
				and (min-device-width: 481px) 
				and (max-device-width: 720px) {
					width: 85%;
					height: calc(100%);
			}
		}
		@media only screen 
			and (min-device-width: 320px) 
			and (max-device-width: 480px) {
				width: 100%;
				height: calc(100%);
			}
		@media only screen 
			and (min-device-width: 481px) 
			and (max-device-width: 720px) {
				width: 85%;
				height: calc(100%);
		}
	}
}
.rp-messenger-notification-container {
	position: fixed;
	bottom: 100px;
	right: 20px;
	width: var(--livechat-widget-width);
	max-width: 100%;
	top: 20px;
	border-radius: 10px;
	overflow: hidden;
	font-weight: $fontWeight;
	display: flex;
	flex-direction: column-reverse;
	overflow-y:auto;
}

.rp-messenger-container {
	@media only screen 
	and (min-device-width: 320px) 
	and (max-device-width: 480px) {
		.rp-messenger {
			top: 0 !important;
			bottom: 0;
			left: 0;
			right: 0;
			width: auto;
			border-radius: 0px;
		}
		.rp-messenger-inner {
			top: 0 !important;
			bottom: 0;
			left: 0;
			right: 0;
			width: auto;
			border-radius: 0px;
			height: calc(100% - 30px);
		}
		.rp-messenger-notification-container {
			left: 0!important;
			right: 0!important;
		}

		&.opened {
			.rp-messenger-trigger {
				display: none;
			}

			.rp-messenger-mobile-close-trigger {
				display: block;
				.rp-cross-icon {
					height: 15px;
					width: 15px;
					margin: 0 auto;
				}
				width: 48px;
				height: 48px;
				display: flex;
				align-items: center;
				transform: translateZ(0px);
				margin: 0px auto;
				border-radius: 4px;
				margin-top: 7px;
				margin-right: 7px;
				transition: background-color 200ms ease 0s;
				&:hover {
					background-color: rgba(0,0,0,0.25);
				}
			}
		}		
	}
}
.popup-message-dialog {
	.el-dialog {
		border-radius: 7px;
	}
	@media only screen 
	and (min-device-width: 320px) 
	and (max-device-width: 480px) {
		.el-dialog {
			width: 95% !important;
		}
	}
	.el-dialog__body {
		padding:0px !important;
	}
	.el-dialog__header {
		padding: 0px !important;
	}
}
.full-image-preview {
	cursor: zoom-out;
	.el-dialog__body {
		padding:0px !important;
	}
	.el-dialog__header {
		padding: 0px !important;
	}
}
.rp-messenger-trigger {
	@include square($size);

	background: $color;
	border-radius: $size;
	position: fixed;
	cursor: pointer;
	bottom: 20px;
	right: 20px;
	max-width: 300px;
	// box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.09), 0 3px 28px 0 rgba(0, 0, 0, 0.2);
	box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.1);
	transition: width 0.6s;
	@include flexFullCenter;
	.count-on-trigger{
		&.when-greeting-animation-active {
			width: 100%;
		}
		.count-on-trigger__greeting-animation {
			display: flex;
			justify-content: space-between;
			.count-on-trigger__greeting-animation____rp-logo {
				background: $color;
				height: 54px;
				width: 54px;
				margin-right: 3px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 50%;
				min-width: 54px;
    			min-height: 54px;
				animation-delay: 100ms;
				opacity: 0;
				transition: opacity 0.4s ease-in-out;
				&.count-on-trigger__greeting-animation____rp-logo--opened{
					opacity: 1;
				}
				&.count-on-trigger__greeting-animation____rp-logo--closed {
					transition: opacity 0.2s ease-in-out;
					opacity: 0;
				}
			}
		}
		.el-badge__content {
			right: 0px;
		}
	}
	.rp-logo-icon {
		height: 44px;
		width: 42.181px;
		position: relative;
		img{
			width: 35px;
			height: 35px;
		}
	}
	.new-message-count-indicator {
		height: 20px;
	}

	.rp-cross-icon {
		width: $size/3.5;
		height: $size/3.5;
	}

	&.opened {
		background: #999999;
		transition: unset !important;
	}

	&.greeting-animation {
		width: 300px;
		background: #fff !important;
		color: #000 !important;
		justify-content: flex-start;

	}

	&.greeting-animation-end {
		background: #fff !important;
		justify-content: flex-start !important;
	}

	.greeting-message {
		display: flex;
		align-items: center;
		padding: 0px 0.3rem 0px 0px;
		overflow: hidden;
		margin-left: 1rem;
		font-weight: 400;
		.agents-info-in-greeting {
			margin-right: 0.5rem;
			margin-bottom: 0rem;
		}
		.greeting-text {
			margin: 4px 0px;
			overflow: hidden;
			h4, p{
				margin: 0px;
			}
			h4 {
				font-weight: 500;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			p{
				font-size: 12px;
			}
		}
		font-size: 14px;
		text-align: left;
	}
}

.rp-messenger-mobile-close-trigger {
	@include square($size/3.5);

	display: none;
	// position: absolute;
	// right: 10px;
	// top: 30px;
	float: right;
}

.rp-messenger-notification-count {
	@include flexFullCenter;

	$size: 25px;

	position: absolute;
	top: -7px;
	left: -7px;
	width: $size;
	height: $size;
	border-radius: 50%;
	background: red;
	color: white;
	font-size: 10px;
	font-weight: 400;
	box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.15);
}

.btn {
	border: none;
	outline: none;
	background: none;
	font-weight: $fontWeight;
	cursor: pointer;
}

a {
	text-decoration: none;
	color: inherit;
}

.rp-messenger-content-conversation-list-widget{
    // position: absolute;
    // top: 105px;
    margin: 16px;
    width: calc(100% - 32px);
    border-radius: 7px;
    background: #fff;
    // padding: 25px;
	height: unset;
	box-shadow: 0 4px 15px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.1), inset 0 2px 0 0 rgba(255, 255, 255, 0.5)
		// box-shadow: 0 1px 0 #fff, 0 1px 6px rgba(0, 0, 0, 0.35);
		// padding-top: 0px;
}

.recent-conversation {
	// margin-bottom: 40px;
}

.rp-powered-by-richpanael {
	border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
	opacity: 0.5;
	padding: 5px 0;
	color: #999999;
	font-size: 12px;
	font-weight: 400;
	position: absolute;
	bottom: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #ffffff;
	width: 100%;
	border-top: 1px solid #eeeeee;
	.powered-by{
		display:flex;
		align-items: center;
		padding: 0 10px;
		.text{
			margin-right:5px;
			font-weight:500;
		}
	}
}


.fade-enter-active {
	animation: fadeIn .4s cubic-bezier(0.1, -0.6, 0.2, 0);
	@keyframes fadeIn {
		from {
			transform: translate3d(0, 20px, 0);
			opacity: 0;
		}

		to {
			transform: translate3d(0, 0, 0);
			opacity: 1;
		}
	}
}

.fade-leave-active {
	animation: fadeOut 0.4s cubic-bezier(0.1, -0.6, 0.2, 0);
	@keyframes fadeOut {
		from {
			opacity: 1;
		}

		to {
			transform: translate3d(0, 20px, 0);
			opacity: 0;
		}
	}
}
.fadeInOpacity-enter-active {
	animation: fadeInOpacity 200s;
	@keyframes fadeInOpacity {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}
}

.fadeInOpacity-leave-active {
	animation: fadeOutOpacity 1s;
	@keyframes fadeOutOpacity {
		from {
			opacity: 1;
		}

		to {
			opacity: 0;
		}
	}
}

/***
		animation
*/


@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(40px, 0, 0);
    transform: translate3d(40px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(20px, 0, 0);
    transform: translate3d(20px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

/////////////////////////////////////fadeInLeft///////////////////////////////
@-webkit-keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-40px, 0, 0);
    transform: translate3d(-40px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-40px, 0, 0);
    transform: translate3d(-40px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

@-webkit-keyframes fadeOutLeft {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-20px, 0, 0);
    transform: translate3d(-20px, 0, 0);
  }
}

@keyframes fadeOutLeft {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-20px, 0, 0);
    transform: translate3d(-20px, 0, 0);
  }
}

.fadeOutLeft {
  -webkit-animation-name: fadeOutLeft;
  animation-name: fadeOutLeft;
}

@-webkit-keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(20px, 0, 0);
    transform: translate3d(20px, 0, 0);
  }
}

@keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(20px, 0, 0);
    transform: translate3d(20px, 0, 0);
  }
}

.fadeOutRight {
  -webkit-animation-name: fadeOutRight;
  animation-name: fadeOutRight;
}


@-webkit-keyframes slideInUp {
  from {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideInUp {
  from {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.slideInUp {
  -webkit-animation-name: slideInUp;
  animation-name: slideInUp;
}

// @-webkit-keyframes fadeInUp {
//   from {
//     opacity: 0;
//     -webkit-transform: translate3d(0, 100%, 0);
//     transform: translate3d(0, 100%, 0);
//   }

//   to {
//     opacity: 1;
//     -webkit-transform: translate3d(0, 0, 0);
//     transform: translate3d(0, 0, 0);
//   }
// }

@keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
@keyframes fadeInUpFromBottom {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 30%, 0);
    transform: translate3d(0, 30%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUpFromBottom {
  -webkit-animation-name: fadeInUpFromBottom;
  animation-name: fadeInUpFromBottom;
}

@keyframes justFadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 0%, 0);
    transform: translate3d(0, 0%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}


.justFadeInUp {
  -webkit-animation-name: justFadeInUp;
  animation-name: justFadeInUp;
}


@-webkit-keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}



@-webkit-keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -170px, 0);
    transform: translate3d(0, -170px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -170px, 0);
    transform: translate3d(0, -170px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
}
.animated.delay-1s {
  -webkit-animation-delay: 200ms;
  animation-delay: 200ms;
}

.animated.faster {
  -webkit-animation-duration: 200ms;
  animation-duration: 200ms;
}

.animated.fastest {
  -webkit-animation-duration: 200ms;
  animation-duration: 200ms;
}
.animated.fast {
  animation-duration: 500ms;
}
div#preloader {
   position: absolute;
   overflow: hidden;
   left: -9999px; 
   top: -9999px;
   height: 1px;
   width: 1px;
}
.rp-tooltip-style {
    font-size: 12px;
    font-family: $font;
	font-weight: 500;
	max-width: 270px;
    line-height: 1.5;
}
ul {
	list-style: disc;
	padding:20px;
	margin:0;
}
ol{
	padding: 20px;
	margin: 0;
}
.see-all-btn {
	display: flex;
	line-height: 1;
	font-size: 14px;
	color: var(--theme-color);
	cursor: pointer;
	background: #fff;
	text-decoration: underline;
	@include for-size(tablet-landscape-up) {
		font-size: 18px;
	}
}
.rp-messenger-widget-content-header {
	border-top-left-radius: 4px;
    border-top-right-radius: 4px;
	padding: 15px 20px;
    border-bottom: 1px solid #eeeeee;
	background: #f9f9f9;
	color: #333;
    font-size: 18px !important;
	font-weight: 400 !important;
	align-items: center;
	justify-content: space-between;
	display: flex;
	line-height: 1;
	@include for-size(tablet-landscape-up){ 
		font-size: 26px !important;
		padding: 20px 40px;
		line-height: $lineHeight;
	}
	@include for-size(desktop-up){
    	padding: $desktopPadding;
		font-size: 26px !important;
		line-height: $lineHeight;
	}
	.see-all-btn {
		font-size: 14px;
		color: var(--theme-color);
		cursor: pointer;
		background: #fff;
	}
}
.el-loading-mask {
	transition: opacity 0s !important;
}

.bounce-enter-active {
	animation: bounce-in 0.3s;
}
.bounce-leave-active {
	animation: bounce-in 0.3s reverse;
}
@keyframes bounce-in {
	0% {
		transform: scale(0.6);
	}
	100% {
		transform: scale(1);
	}
}
.rp-helpdesk-conversation-list-item-online-status-in-agents-info {
	display: flex;
	width: 13px;
	height: 13px;
	position: absolute;
	right: 4px;
	top: 2px;
	background: rgb(112, 213, 38);
	border-width: 2px;
	border-style: solid;
	border-color: rgb(255, 255, 255);
	border-image: initial;
	border-radius: 50%;
}
.rp-basic-card {
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 4px 15px 0 rgba(22, 11, 11, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1), inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
	}
.rp-messenger-order-head-card {
    background: #f9f9f9;
	padding: 1.2rem 1.1rem;
	@include for-size(tablet-landscape-up) {
    	padding: 2.4rem 2.2rem;
  	}
	@include for-size(desktop-up){
		padding: 3.6rem 3.3rem;
	}
	border-radius: 4px;
	border-bottom: 1px solid #eeeeee;
}
.el-button:hover, .el-button:focus {
	background-color: transparent !important;
}
.el-loading-spinner .path {
	stroke: var(--theme-color) !important;
}
.el-loading-spinner .circular {
	animation: loading-rotate 0.7s linear infinite !important
}
.scroll-breadcrumb-and-content {
	overflow: auto;
	max-height: calc(100% - 75px);
}

.rp-messenger-screen-help-and-support-list-content-scroller {
    flex: 1;
	overflow: auto;
	overflow-x: hidden;
	>div{
		margin-top: 3px !important;
	}
}

a.linkified {
	color: $color !important;
	font-weight: 500;
	&:hover{
		text-decoration: underline;
	}
}
.rp-home-screen-card {
	&.loading {
		max-height: 100px;
		min-height: 100px;
	}
	&.after-loading {
		max-height: 500px;
	}
    transition: max-height 0.25s ease-in;
	.el-loading-mask {
		border-radius: 7px;
	}
}
input {
	font-family: $font !important;
}
.rp-make-all-feilds-rtl {
	input, textarea {
		direction: rtl !important;
	}
}
</style>
